<template>
  <div class="page-container">
    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-header"><span class="stat-label">总客户数</span><div class="stat-icon green">👥</div></div>
        <div class="stat-value">{{ stats.total || 0 }}</div>
        <div class="stat-change up" v-if="stats.todayNew">▲ {{ stats.todayNew }} <span class="change-text">今日新增</span></div>
      </div>
      <div class="stat-card">
        <div class="stat-header"><span class="stat-label">今日新增</span><div class="stat-icon blue">📈</div></div>
        <div class="stat-value">{{ stats.todayNew || 0 }}</div>
        <div class="stat-change up" v-if="stats.todayNewGrowth">{{ stats.todayNewGrowth >= 0 ? '▲' : '▼' }} {{ Math.abs(stats.todayNewGrowth) }} <span class="change-text">较昨日</span></div>
      </div>
      <div class="stat-card">
        <div class="stat-header"><span class="stat-label">总余额（USD）</span><div class="stat-icon amber">💰</div></div>
        <div class="stat-value" style="color:#16a34a;">{{ stats.totalBalance | formatMoney }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-header"><span class="stat-label">总浮动盈亏（USD）</span><div class="stat-icon green">📉</div></div>
        <div class="stat-value" :style="{color: (stats.totalFloatingPl||0) >= 0 ? '#16a34a' : '#dc2626'}">{{ stats.totalFloatingPl | formatMoney }}</div>
      </div>
    </div>

    <!-- 搜索 -->
    <div class="filter-bar">
      <el-form :inline="true" :model="search" size="small">
        <el-form-item label="用户ID"><el-input v-model="search.customerNo" placeholder="用户ID" clearable style="width:130px;"></el-input></el-form-item>
        <el-form-item label="姓名"><el-input v-model="search.name" placeholder="姓名" clearable style="width:120px;"></el-input></el-form-item>
        <el-form-item label="国家">
          <el-select v-model="search.countryCode" placeholder="全部" clearable filterable style="width:150px;">
            <el-option v-for="c in countries" :key="c.countryCode" :label="(c.countryCname || c.countryName) + ' ' + c.countryCode" :value="c.countryCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易账号"><el-input v-model="search.accountNo" placeholder="MT5 Login" clearable style="width:140px;"></el-input></el-form-item>
        <el-form-item label="手机号"><el-input v-model="search.phone" placeholder="手机号" clearable style="width:130px;"></el-input></el-form-item>
        <el-form-item label="邮箱"><el-input v-model="search.email" placeholder="邮箱" clearable style="width:160px;"></el-input></el-form-item>
        <el-form-item label="客户组">
          <el-select v-model="search.groupId" placeholder="全部" clearable style="width:130px;">
            <el-option v-for="g in groupOptions" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="search.status" placeholder="全部" clearable style="width:100px;">
            <el-option label="正常" :value="1"></el-option><el-option label="禁用" :value="2"></el-option>
            <el-option label="已注销" :value="3"></el-option><el-option label="黑名单" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="激活">
          <el-select v-model="search.isActive" placeholder="全部" clearable style="width:100px;">
            <el-option label="已激活" :value="2"></el-option><el-option label="未激活" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户标签">
          <el-select v-model="search.tagId" placeholder="全部" clearable style="width:120px;">
            <el-option v-for="t in tagOptions" :key="t.id" :label="t.tagName" :value="t.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注册方式">
          <el-select v-model="search.regWay" placeholder="全部" clearable style="width:100px;">
            <el-option label="H5" :value="1"></el-option><el-option label="Android" :value="2"></el-option>
            <el-option label="IOS" :value="3"></el-option><el-option label="PC" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐人"><el-input v-model="search.referrer" placeholder="推荐人" clearable style="width:120px;"></el-input></el-form-item>
        <el-form-item label="激活时间">
          <el-date-picker v-model="search.activateDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:260px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="注册日期">
          <el-date-picker v-model="search.regDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:260px;"></el-date-picker>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">搜索</el-button><el-button @click="resetSearch">重置</el-button></el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-wrapper">
      <div class="table-header">
        <span class="table-title">客户列表</span>
        <div class="table-actions">
          <button v-auth="'business:clientAccount:add'" class="btn btn-primary btn-sm" @click="openAddClient">+ 新增客户</button>
          <button v-auth="'business:clientAccount:tag'" class="btn btn-secondary btn-sm" @click="openBatchTag('add')">🏷 添加客户标签</button>
          <button v-auth="'business:clientAccount:tag'" class="btn btn-secondary btn-sm" @click="openBatchTag('remove')">🗑 删除客户标签</button>
          <button v-auth="'business:clientAccount:transfer'" class="btn btn-secondary btn-sm" @click="openTransferGroup">🔄 转组</button>
          <button v-auth="'business:clientAccount:export'" class="btn btn-secondary btn-sm" @click="handleExport">📥 导出</button>
        </div>
      </div>
      <el-table ref="clientTable" class="client-table" :data="tableData" v-loading="loading" style="width:100%;" @expand-change="onExpand" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="30"></el-table-column>
        <el-table-column type="expand" width="30" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.subAccounts && scope.row.subAccounts.length" class="expand-content">
              <div class="sub-table-title">▼ 子账户明细</div>
              <!-- 子表用 min-width 不用 width：所有列都是 min-width 时 element 才会按比例把表铺满整行，
                   铺完就是原型那种「列很宽、横跨整行」的效果；写死 width 的话表只有 1150px 会贴着左边留一大片空白 -->
              <el-table class="sub-table" :data="scope.row.subAccounts" size="mini">
                <el-table-column label="账户类型" :min-width="100">
                  <template slot-scope="s">
                    <span class="badge" :class="s.row.accountType===1?'blue':s.row.accountType===2?'green':'red'">{{ s.row.accountType===1?'钱包账户':s.row.accountType===2?'真实账户':'模拟账户' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="accountNo" label="交易账号" :min-width="120" class-name="mono-cell"></el-table-column>
                <el-table-column label="交易账户组" :min-width="150">
                  <template slot-scope="s">{{ s.row.tradeGroupName || '-' }}</template>
                </el-table-column>
                <el-table-column prop="balance" label="账户余额(USD)" :min-width="130" class-name="mono-cell"></el-table-column>
                <el-table-column prop="totalDeposit" label="充值总额(USD)" :min-width="130" class-name="mono-cell"></el-table-column>
                <el-table-column prop="totalWithdrawal" label="累计提现(USD)" :min-width="130" class-name="mono-cell"></el-table-column>
                <el-table-column prop="equity" label="净值(USD)" :min-width="130" class-name="mono-cell"></el-table-column>
                <el-table-column label="浮动盈亏(USD)" :min-width="140" class-name="mono-cell">
                  <template slot-scope="s"><span :style="plStyle(s.row.floatingPl)">{{ s.row.floatingPl }}</span></template>
                </el-table-column>
                <el-table-column label="操作" :min-width="110">
                  <template slot-scope="s">
                    <div class="sub-actions">
                      <!-- 图标 1:1 抄原型：查看=👁、编辑=那支描边铅笔 svg（原型就是这两个） -->
                      <button class="icon-btn" title="查看详情" @click="showSubAccountDetail(scope.row, s.row)">👁</button>
                      <button v-auth="'business:clientAccount:edit'" class="icon-btn icon-btn-edit" title="编辑" @click="editSubAccount(scope.row, s.row)"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg></button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="customerNo" label="用户ID" width="120" class-name="mono-cell"></el-table-column>
        <el-table-column prop="name" label="姓名" width="90"></el-table-column>
        <el-table-column label="国家" width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ countryLabel(scope.row.countryCode) }}</template>
        </el-table-column>
        <el-table-column label="手机号" width="150"><template slot-scope="{row}">{{ (row.phonePrefix ? '+' + row.phonePrefix + ' ' : '') + (row.phoneNumber || '') }}</template></el-table-column>
        <el-table-column prop="email" label="邮箱" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="注册方式" width="90">
          <template slot-scope="scope">{{ regLabel(scope.row.regWay) }}</template>
        </el-table-column>
        <el-table-column label="客户组" width="110" show-overflow-tooltip>
          <template slot-scope="scope">{{ groupLabel(scope.row.groupId) }}</template>
        </el-table-column>
        <!-- 列宽要放得下一个 6 字标签胶囊 + 「…」（实测「KYC已拒绝」胶囊约 89px，
             加上点点和单元格内边距约 99px）；原型里这一列也是按单个标签撑开的 -->
        <el-table-column label="客户标签" width="140">
          <template slot-scope="scope">
            <!-- 只露第一个标签，多于一个时补「…」，鼠标悬浮用 tooltip 看全部标签。
                标签名是后台自定义的，再宽的列也可能被撑爆，所以只有一个标签时也保留 tooltip
                （tooltip 用 light 白底，彩色胶囊才看得清：胶囊底色是带透明度的） -->
            <el-tooltip
              v-if="riskTags(scope.row).length"
              placement="top"
              effect="light"
              popper-class="ctag-tip-popper"
            >
              <div slot="content" class="ctag-tip">
                <span v-for="t in riskTags(scope.row)" :key="t.n" class="ctag" :style="tagPillStyle(t.c)"><span class="ctag-dot" :style="{background: t.c}"></span>{{ t.n }}</span>
              </div>
              <span class="ctag-cell">
                <span class="ctag" :style="tagPillStyle(riskTags(scope.row)[0].c)"><span class="ctag-dot" :style="{background: riskTags(scope.row)[0].c}"></span>{{ riskTags(scope.row)[0].n }}</span>
                <span v-if="riskTags(scope.row).length > 1" class="ctag-more">…</span>
              </span>
            </el-tooltip>
            <span v-else style="color:#9ca3af;">--</span>
          </template>
        </el-table-column>
        <el-table-column prop="referrer" label="推荐人" width="90"></el-table-column>
        <el-table-column label="MT5账户" width="80" class-name="mono-cell">
          <template slot-scope="scope">{{ (scope.row.subAccounts||[]).length }}</template>
        </el-table-column>
        <el-table-column prop="balance" label="账户余额(USD)" width="130" class-name="mono-cell"></el-table-column>
        <el-table-column prop="equity" label="净值(USD)" width="130" class-name="mono-cell"></el-table-column>
        <el-table-column label="浮动盈亏" width="120" class-name="mono-cell">
          <template slot-scope="scope"><span :style="plStyle(scope.row.floatingPl)">{{ scope.row.floatingPl }}</span></template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <span class="badge" :class="statusBadge(scope.row.status)"><span class="badge-dot"></span>{{ statusLabel(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="激活" width="90">
          <template slot-scope="scope">
            <span class="badge" :class="scope.row.isActive===2?'green':'gray'">{{ scope.row.isActive===2?'已激活':'未激活' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="regTime" label="注册时间" width="160"></el-table-column>
        <el-table-column prop="activateTime" label="激活时间" width="160"></el-table-column>
        <el-table-column label="备注" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.editingRemark" style="display:flex;gap:4px;">
              <el-input v-model="scope.row.remarkEdit" size="small" style="width:130px;" :ref="'remarkInput' + scope.row.id" @blur="saveRemark(scope.row)" @keyup.enter.native="saveRemark(scope.row)"></el-input>
            </div>
            <span v-else class="remark-cell" :class="{ 'remark-cell-empty': !scope.row.remark }" :title="scope.row.remark || '点击添加备注'" @click="startEditRemark(scope.row)">{{ scope.row.remark || '点击添加' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" class-name="op-cell" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
            <el-button v-auth="'business:clientAccount:edit'" type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-dropdown trigger="click" @command="(cmd)=>handleMore(cmd,scope.row)">
              <el-button type="text" size="small">更多 ▾</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-auth="'business:clientAccount:resetPwd'" command="pwd">重置密码</el-dropdown-item>
                <el-dropdown-item v-auth="'business:clientAccount:status'" command="disable" divided>禁用账户</el-dropdown-item>
                <el-dropdown-item v-auth="'business:clientAccount:status'" command="cancel" style="color:#f56c6c;">注销账户</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="(v)=>{pageSize=v;fetchList()}" @current-change="(v)=>{pageNum=v;fetchList()}"
        :current-page="pageNum" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
    </div>

    <!-- 新增客户弹窗 -->
    <el-dialog :visible.sync="addClientVisible" width="900px" :close-on-click-modal="false">
      <div slot="title"><h3 style="margin:0;">新增客户</h3></div>
      <div class="edit-section">
        <div class="edit-section-title">基本信息</div>
        <el-form :model="addForm" label-width="80px" size="small">
          <el-row :gutter="12">
            <el-col :span="12"><el-form-item label="姓名" required><el-input v-model="addForm.name" placeholder="请输入姓名"></el-input></el-form-item></el-col>
            <el-col :span="12"><el-form-item label="手机号" required><el-input v-model="addForm.phone" placeholder="请输入手机号"></el-input></el-form-item></el-col>
            <el-col :span="12"><el-form-item label="邮箱"><el-input v-model="addForm.email" placeholder="请输入邮箱"></el-input></el-form-item></el-col>
            <el-col :span="12">
              <el-form-item label="客户组">
                <el-select v-model="addForm.groupId" placeholder="请选择" style="width:100%;">
                  <el-option v-for="g in groupOptions" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户标签">
                <el-select v-model="addForm.tagId" placeholder="请选择" style="width:100%;">
                  <el-option v-for="t in tagOptions" :key="t.id" :label="t.tagName" :value="t.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"><el-form-item label="推荐人"><el-input v-model="addForm.referrer" placeholder="请输入推荐人ID"></el-input></el-form-item></el-col>
            <el-col :span="24"><el-form-item label="备注"><el-input type="textarea" v-model="addForm.remark" rows="3" placeholder="请输入备注"></el-input></el-form-item></el-col>
          </el-row>
        </el-form>
      </div>
      <div class="edit-section" style="margin-top:16px;">
        <div class="edit-section-title">证件信息</div>
        <el-form :model="addForm" label-width="80px" size="small">
          <el-row :gutter="12">
            <el-col :span="8">
              <el-form-item label="证件类型">
                <el-select v-model="addForm.docType" style="width:100%;">
                  <el-option label="身份证" :value="1"></el-option><el-option label="护照" :value="2"></el-option>
                  <el-option label="驾驶证" :value="3"></el-option><el-option label="居留证" :value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8"><el-form-item label="证件号码"><el-input v-model="addForm.docNumber" placeholder="请输入证件号码"></el-input></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="证件姓名"><el-input v-model="addForm.docName" placeholder="请输入证件姓名"></el-input></el-form-item></el-col>
            <el-col :span="6"><el-form-item label="证件国籍"><el-select v-model="addForm.nationality" placeholder="请选择国籍" filterable clearable style="width:100%;"><el-option v-for="c in countries" :key="c.countryCode" :label="(c.countryCname||c.countryName) + ' ' + c.countryCode" :value="c.countryCode"></el-option></el-select></el-form-item></el-col>
            <el-col :span="12">
              <el-form-item label="有效期">
                <div style="display:flex;gap:6px;align-items:center;">
                  <el-date-picker v-model="addForm.validFrom" type="date" placeholder="开始" value-format="yyyy-MM-dd" style="flex:1;"></el-date-picker>
                  <span style="color:#9ca3af;font-size:12px;">至</span>
                  <el-date-picker v-model="addForm.validTo" type="date" placeholder="结束" value-format="yyyy-MM-dd" style="flex:1;"></el-date-picker>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="认证状态">
                <el-tag type="info" size="small">未认证</el-tag>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="display:flex;gap:16px;flex-wrap:wrap;margin-top:8px;">
          <div class="doc-upload-item" v-for="(item, idx) in [{label:'证件正面',icon:'🪪'},{label:'证件反面',icon:'🪪'},{label:'手持证件',icon:'👤'}]" :key="idx">
            <div class="doc-upload-box" @click="$refs.docUpload[idx].click()">
              <span v-if="!docPreviews[idx]" style="font-size:28px;">{{ item.icon }}</span>
              <img v-else :src="docPreviews[idx]" style="width:100%;height:100%;object-fit:cover;border-radius:8px;">
              <div class="doc-upload-overlay"><span>📷 上传</span></div>
              <input type="file" accept="image/*" :ref="'docUpload'" style="display:none;" @change="previewDoc($event, idx)">
            </div>
            <div style="font-size:11px;color:#9ca3af;margin-top:4px;text-align:center;">{{ item.label }}</div>
          </div>
        </div>
      </div>
      <div slot="footer"><el-button @click="addClientVisible=false">取消</el-button><el-button v-auth="'business:clientAccount:add'" type="primary" @click="saveAddClient">确定</el-button></div>
    </el-dialog>

    <!-- 添加客户标签弹窗 -->
    <el-dialog :visible.sync="addTagVisible" width="500px" :close-on-click-modal="false">
      <div slot="title"><h3 style="margin:0;">添加客户标签</h3></div>
      <el-form label-width="80px" size="small">
        <el-form-item label="选择客户" required>
          <div style="display:flex;gap:8px;margin-bottom:8px;">
            <el-input v-model="batchTag.userIds" placeholder="输入用户ID，多个用逗号分隔"></el-input>
            <el-button size="small" @click="batchSelectAll('tag')">全选当前</el-button>
          </div>
          <div style="max-height:100px;overflow-y:auto;border:1px solid #e8ecf2;border-radius:6px;padding:8px;font-size:12px;color:#9ca3af;">{{ batchTag.tip || '未选择客户' }}</div>
        </el-form-item>
        <el-form-item label="设置标签" required>
          <el-checkbox-group v-model="batchTag.selectedTags" style="display:flex;flex-direction:column;gap:6px;max-height:180px;overflow-y:auto;">
            <el-checkbox v-for="t in tagOptions" :key="t.id" :label="t.id">{{ t.tagName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer"><el-button @click="addTagVisible=false">取消</el-button><el-button v-auth="'business:clientAccount:tag'" type="primary" @click="saveBatchTag">确定</el-button></div>
    </el-dialog>

    <!-- 删除客户标签弹窗 -->
    <el-dialog :visible.sync="delTagVisible" width="500px" :close-on-click-modal="false">
      <div slot="title"><h3 style="margin:0;">删除客户标签</h3></div>
      <el-form label-width="80px" size="small">
        <el-form-item label="选择客户" required>
          <div style="display:flex;gap:8px;margin-bottom:8px;">
            <el-input v-model="batchDelTag.userIds" placeholder="输入用户ID，多个用逗号分隔"></el-input>
            <el-button size="small" @click="batchSelectAll('delTag')">全选当前</el-button>
          </div>
          <div style="max-height:100px;overflow-y:auto;border:1px solid #e8ecf2;border-radius:6px;padding:8px;font-size:12px;color:#9ca3af;">{{ batchDelTag.tip || '未选择客户' }}</div>
        </el-form-item>
      </el-form>
      <div style="background:rgba(239,68,68,0.08);border:1px solid rgba(239,68,68,0.2);border-radius:6px;padding:10px 14px;font-size:12px;color:#b91c1c;display:flex;align-items:flex-start;gap:8px;">
        <span style="font-size:14px;">⚠</span>
        <div>删除标签操作将移除所选客户对应的所有标签。此操作不可撤销，请谨慎操作。</div>
      </div>
      <div slot="footer"><el-button @click="delTagVisible=false">取消</el-button><el-button v-auth="'business:clientAccount:tag'" type="danger" @click="saveBatchDelTag">确定删除</el-button></div>
    </el-dialog>

    <!-- 转组弹窗 -->
    <el-dialog :visible.sync="transferVisible" width="500px" :close-on-click-modal="false">
      <div slot="title"><h3 style="margin:0;">转组</h3></div>
      <el-form label-width="90px" size="small">
        <el-form-item label="选择客户" required>
          <div style="display:flex;gap:8px;margin-bottom:8px;">
            <el-input v-model="transferForm.userIds" placeholder="输入用户ID，多个用逗号分隔" @blur="resolveTransferGroups"></el-input>
            <el-button size="small" @click="batchSelectAll('transfer')">全选当前</el-button>
          </div>
          <div style="max-height:100px;overflow-y:auto;border:1px solid #e8ecf2;border-radius:6px;padding:8px;font-size:12px;color:#9ca3af;">{{ transferForm.tip || '未选择客户' }}</div>
        </el-form-item>
        <el-form-item label="目标客户组" required>
          <el-select v-model="transferForm.targetGroupId" :placeholder="transferGroupOptions.length ? '请选择目标客户组' : '请先选择客户'" style="width:100%;">
            <el-option v-for="g in transferGroupOptions" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
          </el-select>
          <div style="font-size:11px;color:#9ca3af;margin-top:4px;">
            {{ transferCountryCode ? '仅显示所选客户所在国家（' + countryLabel(transferCountryCode) + '）的客户组' : '目标客户组按所选客户所在国家查询' }}
          </div>
        </el-form-item>
        <el-form-item label="转组原因">
          <el-input type="textarea" v-model="transferForm.reason" rows="3" placeholder="请输入转组原因"></el-input>
        </el-form-item>
      </el-form>
      <div style="background:rgba(245,158,11,0.08);border:1px solid rgba(245,158,11,0.2);border-radius:6px;padding:10px 14px;font-size:12px;color:#b45309;display:flex;align-items:flex-start;gap:8px;">
        <span style="font-size:14px;">⚠</span>
        <div>转组操作将修改所选客户所属的客户组。请在转组前确认目标组是否正确。</div>
      </div>
      <div slot="footer"><el-button @click="transferVisible=false">取消</el-button><el-button v-auth="'business:clientAccount:transfer'" type="primary" @click="saveTransferGroup">确定</el-button></div>
    </el-dialog>

    <!-- 编辑客户弹窗 -->
    <el-dialog :visible.sync="editVisible" width="900px" :close-on-click-modal="false" v-if="editForm">
      <div slot="title"><h3 style="margin:0;">编辑账户</h3></div>
      <div class="edit-section">
        <div class="edit-section-title">基本信息</div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px;">
          <div class="edit-form-group">
            <label>头像</label>
            <div style="display:flex;align-items:center;gap:12px;">
              <div class="avatar-circle" style="width:48px;height:48px;font-size:18px;cursor:pointer;" @click="$refs.editAvatarInput.click()">{{ (editForm.name||'?')[0] }}</div>
              <input type="file" ref="editAvatarInput" accept="image/*" style="display:none;">
              <span style="font-size:12px;color:#9ca3af;cursor:pointer;" @click="$refs.editAvatarInput.click()">点击上传头像</span>
            </div>
          </div>
          <div class="edit-form-group"><label>昵称</label><el-input v-model="editForm.nickName" size="small" placeholder="请输入昵称"></el-input></div>
          <div class="edit-form-group"><label>用户ID</label><el-input :value="editForm.customerNo" size="small" disabled></el-input></div>
          <div class="edit-form-group"><label>姓名</label><el-input v-model="editForm.name" size="small" placeholder="请输入姓名"></el-input></div>
          <div class="edit-form-group"><label>手机号</label><div style="display:flex;gap:6px;"><el-input v-model="editForm.phonePrefix" size="small" placeholder="区号" style="width:70px;"></el-input><el-input v-model="editForm.phoneNumber" size="small" placeholder="请输入手机号" style="flex:1;"></el-input></div></div>
          <div class="edit-form-group"><label>邮箱</label><el-input v-model="editForm.email" size="small" placeholder="请输入邮箱"></el-input></div>
          <div class="edit-form-group">
            <label>状态</label><el-select v-model="editForm.status" size="small" style="width:100%;">
              <el-option label="正常" :value="1"></el-option><el-option label="禁用" :value="2"></el-option><el-option label="已注销" :value="3"></el-option>
            </el-select>
          </div>
          <div class="edit-form-group">
            <label>客户标签</label><el-select v-model="editForm.tagId" size="small" style="width:100%;">
              <el-option v-for="t in tagOptions" :key="t.id" :label="t.tagName" :value="t.id"></el-option>
            </el-select>
          </div>
          <div class="edit-form-group">
            <label>客户组</label><el-select v-model="editForm.groupId" size="small" style="width:100%;">
              <el-option v-for="g in groupOptions" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
            </el-select>
          </div>
          <div class="edit-form-group"><label>出生国家</label><el-select v-model="editForm.birthCountry" size="small" filterable clearable style="width:100%;"><el-option v-for="c in countries" :key="c.countryCode" :label="(c.countryCname||c.countryName) + ' ' + c.countryCode" :value="c.countryCode"></el-option></el-select></div>
          <div class="edit-form-group"><label>国籍</label><el-select v-model="editForm.nationality" size="small" filterable clearable style="width:100%;"><el-option v-for="c in countries" :key="c.countryCode" :label="(c.countryCname||c.countryName) + ' ' + c.countryCode" :value="c.countryCode"></el-option></el-select></div>
          <div class="edit-form-group"><label>居住国家</label><el-select v-model="editForm.residenceCountry" size="small" filterable clearable style="width:100%;"><el-option v-for="c in countries" :key="c.countryCode" :label="(c.countryCname||c.countryName) + ' ' + c.countryCode" :value="c.countryCode"></el-option></el-select></div>
          <div class="edit-form-group"><label>税务居民地</label><el-input v-model="editForm.taxResidence" size="small" placeholder="请输入税务居民地"></el-input></div>
          <div class="edit-form-group"><label>税务识别号</label><el-input v-model="editForm.tinNumber" size="small" placeholder="请输入税务识别号"></el-input></div>
        </div>
      </div>
      <div class="edit-section">
        <div class="edit-section-title">用户资料</div>
        <div style="display:flex;gap:8px;margin-bottom:16px;border-bottom:1px solid #e8ecf2;">
          <button class="tab-btn" :class="{active:editTab==='id'}" @click="editTab='id'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">证件信息</button>
          <button class="tab-btn" :class="{active:editTab==='address'}" @click="editTab='address'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">地址信息</button>
          <button class="tab-btn" :class="{active:editTab==='bank'}" @click="editTab='bank'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">银行卡</button>
          <button class="tab-btn" :class="{active:editTab==='wallet'}" @click="editTab='wallet'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">电子钱包</button>
          <button class="tab-btn" :class="{active:editTab==='perm'}" @click="editTab='perm'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">账户权限设置</button>
        </div>
        <div v-show="editTab==='id'"><div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;padding:12px;background:#f4f6fb;border:1px solid #e8ecf2;border-radius:8px;margin-bottom:12px;">
          <div class="edit-form-group"><label>证件类型</label><el-select v-model="editIdCard.docType" size="small" style="width:100%;"><el-option label="身份证" :value="1"></el-option><el-option label="护照" :value="2"></el-option><el-option label="驾驶证" :value="3"></el-option><el-option label="居留许可" :value="4"></el-option></el-select></div>
          <div class="edit-form-group"><label>证件号码</label><el-input v-model="editIdCard.docNumber" size="small"></el-input></div>
          <div class="edit-form-group"><label>证件姓名</label><el-input v-model="editIdCard.docName" size="small"></el-input></div>
          <div class="edit-form-group"><label>证件国籍</label><el-select v-model="editIdCard.nationality" size="small" filterable clearable style="width:100%;"><el-option v-for="c in countries" :key="c.countryCode" :label="(c.countryCname||c.countryName) + ' ' + c.countryCode" :value="c.countryCode"></el-option></el-select></div>
          <div class="edit-form-group"><label>有效期</label><div style="display:flex;gap:6px;align-items:center;"><el-date-picker v-model="editIdCard.validFrom" type="date" value-format="yyyy-MM-dd" size="small" style="flex:1;"></el-date-picker><span style="color:#9ca3af;font-size:12px;">至</span><el-date-picker v-model="editIdCard.validTo" type="date" value-format="yyyy-MM-dd" size="small" style="flex:1;"></el-date-picker></div></div>
          <div class="edit-form-group"><label>认证状态</label><el-tag :type="verifyStatusType(editIdCard.status)" size="small">{{ docStatusLabel(editIdCard.status) }}</el-tag></div>
        </div>
          <div>
            <!-- 证件上传区域 -->
            <div style="display:flex;gap:16px;flex-wrap:wrap;">
              <div
                v-for="(item, idx) in [{label:'证件正面',icon:'🪪'},{label:'证件反面',icon:'🪪'},{label:'手持证件',icon:'👤'}]"
                :key="idx"
                style="width:140px;text-align:center;"
              >
                <div
                  class="doc-upload-box"
                  style="width:140px;height:100px;border:1px dashed #d1d9e6;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#9ca3af;background:#f4f6fb;margin-bottom:6px;cursor:pointer;position:relative;overflow:hidden;"
                >
                  <span style="font-size:28px;">{{ item.icon }}</span>
                  <div class="doc-upload-overlay">
                    <span>📷 上传</span>
                  </div>
                </div>
                <div style="font-size:11px;color:#9ca3af;">{{ item.label }}</div>
              </div>
            </div>
          </div>
        </div>

            <!-- 银行卡 Tab -->
            <div v-show="editTab === 'bank'">
              <div
                v-for="(card, idx) in editBankCards"
                :key="idx"
                style="padding:14px;background:#f4f6fb;border:1px solid #e8ecf2;border-radius:8px;position:relative;margin-bottom:12px;"
              >
                <!-- 状态标签 -->
                <div style="position:absolute;top:10px;right:14px;">
                  <el-tag :type="verifyStatusType(card.status)" size="mini">
                    {{ verifyStatusLabel(card.status) }}
                  </el-tag>
                </div>

                <!-- 表单字段 -->
                <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:12px;">
                  <div class="edit-form-group">
                    <label class="required">开户银行</label>
                    <el-input v-model="card.bankName" size="small"></el-input>
                  </div>
                  <div class="edit-form-group">
                    <label>银行编码</label>
                    <el-input v-model="card.bankCode" size="small" placeholder="如 BCA/BNI"></el-input>
                  </div>
                  <div class="edit-form-group">
                    <label class="required">银行卡号</label>
                    <el-input v-model="card.bankAccount" size="small"></el-input>
                  </div>
                  <div class="edit-form-group">
                    <label class="required">持卡人</label>
                    <el-input v-model="card.bankHolder" size="small"></el-input>
                  </div>
                  <div class="edit-form-group">
                    <label>支行信息</label>
                    <el-input v-model="card.branch" size="small"></el-input>
                  </div>
                  <div class="edit-form-group">
                    <label>国家/地区</label>
                    <el-select v-model="card.countryCode" size="small" filterable style="width:100%;">
                      <el-option v-for="c in countries" :key="c.countryCode" :label="(c.countryCname||c.countryName) + ' ' + c.countryCode" :value="c.countryCode"></el-option>
                    </el-select>
                  </div>
                  <!-- ====== 新增三个字段 ====== -->
                  <div class="edit-form-group">
                    <label>SWIFT Code</label>
                    <el-input v-model="card.bankSwift" size="small" placeholder="8或11位"></el-input>
                  </div>
                  <div class="edit-form-group">
                    <label>IBAN</label>
                    <el-input v-model="card.bankIban" size="small" placeholder="最长34位"></el-input>
                  </div>
                  <div class="edit-form-group">
                    <label>Sort Code</label>
                    <el-input v-model="card.bankSortCode" size="small" placeholder="如 12-34-56"></el-input>
                  </div>
                  <!-- ====================== -->
                </div>

                <!-- 删除按钮 -->
                <div style="display:flex;justify-content:flex-end;margin-top:8px;">
                  <el-button type="danger" size="mini" @click="deleteBankCard(idx)">删除</el-button>
                </div>
              </div>

              <!-- 新增按钮 -->
              <el-button type="primary" size="small" @click="addBankCard">
                + 新增银行卡
              </el-button>
            </div>

            <!-- 电子钱包 Tab -->
            <div v-show="editTab === 'wallet'">
              <div
                v-for="(w, idx) in editWallets"
                :key="idx"
                style="display:flex;flex-direction:column;gap:12px;padding:14px;background:#f4f6fb;border:1px solid #e8ecf2;border-radius:8px;position:relative;margin-bottom:12px;"
              >
                <!-- 头部 -->
                <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;">
        <span style="font-weight:600;font-size:14px;color:#1a2236;">
          {{ walletTypeLabel(w.walletType) }}
        </span>
                  <el-tag :type="w.status === 3 ? 'success' : w.status === 4 ? 'danger' : w.status === 2 ? 'warning' : 'info'" size="mini">
                    {{ verifyStatusLabel(w.status) }}
                  </el-tag>
                </div>

                <!-- 表单字段 -->
                <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:12px;">
                  <div class="edit-form-group">
                    <label>钱包类型</label>
                    <el-select v-model="w.walletType" size="small" style="width:100%;">
                      <el-option label="USDT-TRC20" :value="1"></el-option>
                      <el-option label="USDT-ERC20" :value="2"></el-option>
                      <el-option label="USDT-Polygon" :value="9"></el-option>
                      <el-option label="USDT-BEP20" :value="10"></el-option>
                      <el-option label="Bitcoin" :value="3"></el-option>
                      <el-option label="Ethereum" :value="4"></el-option>
                    </el-select>
                  </div>
                  <div class="edit-form-group" style="grid-column:span 2;">
                    <label>钱包地址</label>
                    <el-input v-model="w.address" size="small" placeholder="请输入钱包地址"></el-input>
                  </div>
                  <div class="edit-form-group">
                    <label>持有人</label>
                    <el-input v-model="w.holder" size="small" placeholder="请输入持有人"></el-input>
                  </div>
                </div>

                <!-- 截图上传 -->
                <div style="display:flex;gap:16px;flex-wrap:wrap;">
                  <div style="width:140px;text-align:center;">
                    <div
                      class="doc-upload-box"
                      style="width:140px;height:100px;border:1px dashed #d1d9e6;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#9ca3af;font-size:28px;background:#f4f6fb;margin-bottom:6px;cursor:pointer;position:relative;overflow:hidden;"
                    >
                      <span>📱</span>
                      <div class="doc-upload-overlay">
                        <span>📷 上传</span>
                      </div>
                    </div>
                    <div style="font-size:11px;color:#9ca3af;">电子钱包截图</div>
                  </div>
                </div>

                <!-- 删除按钮 -->
                <div style="display:flex;justify-content:flex-end;margin-top:4px;">
                  <el-button type="danger" size="mini" @click="deleteWallet(idx)">删除</el-button>
                </div>
              </div>

              <!-- 新增按钮 -->
              <el-button type="primary" size="small" @click="addWallet">
                + 新增电子钱包
              </el-button>
            </div>

            <!-- 权限设置 Tab -->
            <div v-show="editTab === 'perm'">
              <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:12px;">
                <div class="perm-card"><div class="perm-icon green">⇄</div><div class="perm-info"><div class="perm-title">内部转账</div><div class="perm-desc">模拟账户默认不可转账</div></div><el-switch v-model="permForm.internalTransfer" :active-value="1" :inactive-value="2"></el-switch></div>
                <div class="perm-card"><div class="perm-icon blue">📈</div><div class="perm-info"><div class="perm-title">允许开仓</div><div class="perm-desc">允许客户开立新仓位</div></div><el-switch v-model="permForm.allowOpen" :active-value="1" :inactive-value="2"></el-switch></div>
                <div class="perm-card"><div class="perm-icon orange">📉</div><div class="perm-info"><div class="perm-title">允许平仓</div><div class="perm-desc">允许客户平仓现有仓位</div></div><el-switch v-model="permForm.allowClose" :active-value="1" :inactive-value="2"></el-switch></div>
                <div class="perm-card"><div class="perm-icon red">💰</div><div class="perm-info"><div class="perm-title">出金权限</div><div class="perm-desc">允许客户提取资金</div></div><el-switch v-model="permForm.withdraw" :active-value="1" :inactive-value="2"></el-switch></div>
                <div class="perm-card"><div class="perm-icon cyan">💳</div><div class="perm-info"><div class="perm-title">入金权限</div><div class="perm-desc">允许客户充值资金</div></div><el-switch v-model="permForm.deposit" :active-value="1" :inactive-value="2"></el-switch></div>
              </div>
              <div style="background:rgba(245,158,11,0.08);border:1px solid rgba(245,158,11,0.2);border-radius:6px;padding:10px 14px;font-size:12px;color:#b45309;display:flex;align-items:flex-start;gap:8px;margin-top:16px;"><span>⚠</span><div>关闭所有权限将自动锁定账户。不会修改交易已经在进行中的订单。</div></div>
            </div>

            <!-- 地址信息 Tab（原型1:1） -->
            <div v-show="editTab === 'address'" style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;padding:12px;background:#f4f6fb;border:1px solid #e8ecf2;border-radius:8px;">
              <template v-if="editAddress.countryCode==='CN'">
                <div class="edit-form-group" style="grid-column:span 3;">
                  <label>省/市/区</label>
                  <el-cascader
                    v-model="editAddress.pca"
                    :options="chinaAreaOptions"
                    size="small"
                    placeholder="请选择省/市/区"
                    style="width:100%;"
                    clearable
                    @change="onPcaChange"></el-cascader>
                </div>
              </template>
              <div class="edit-form-group" :style="editAddress.countryCode==='CN'?{gridColumn:'span 3'}:{gridColumn:'span 2'}">
                <label>居住地址</label>
                <el-input v-model="editAddress.address" size="small" placeholder="请输入居住地址"></el-input>
              </div>
              <div class="edit-form-group">
                <label>地址证明类型</label>
                <el-select v-model="editAddress.proofType" size="small" style="width:100%;" clearable>
                  <el-option label="水电账单" :value="1"></el-option>
                  <el-option label="燃气账单" :value="5"></el-option>
                  <el-option label="银行对账单" :value="2"></el-option>
                  <el-option label="政府信函" :value="3"></el-option>
                  <el-option label="居住证" :value="4"></el-option>
                </el-select>
              </div>
              <div class="edit-form-group">
                <label>提交时间</label>
                <el-input :value="editAddress.createDate || '-'" size="small" disabled></el-input>
              </div>
              <div style="grid-column:span 3;display:flex;gap:16px;align-items:flex-end;">
                <div style="width:140px;text-align:center;">
                  <div class="doc-upload-box" @click="$refs.addrFileInput&&$refs.addrFileInput[0].click()" style="width:140px;height:100px;border:1px dashed #d1d9e6;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#9ca3af;font-size:28px;background:#f4f6fb;cursor:pointer;position:relative;overflow:hidden;">
                    <img v-if="editAddress.proofFileUrls" :src="editAddress.proofFileUrls" style="width:100%;height:100%;object-fit:cover;">
                    <span v-else>📄</span>
                    <div class="doc-upload-overlay"><span style="color:#fff;font-size:13px;font-weight:500;">📷 上传</span></div>
                    <input type="file" accept="image/*" style="display:none;" ref="addrFileInput" @change="previewAddrDoc">
                  </div>
                  <div style="font-size:11px;color:#9ca3af;">地址证明文件</div>
                </div>
                <el-input v-model="editAddress.proofFileUrls" size="small" placeholder="证明文件URL（可手动输入）" style="flex:1;"></el-input>
              </div>
            </div>
          </div>
      <div slot="footer"><el-button @click="editVisible=false">取消</el-button><el-button v-auth="'business:clientAccount:edit'" type="primary" @click="saveEdit">确定</el-button></div>
    </el-dialog>

    <!-- 客户详情弹窗 -->
    <el-dialog :visible.sync="detailVisible" width="960px" :close-on-click-modal="false" v-if="detail">
      <div slot="title"><h3 style="margin:0;">客户详情</h3></div>
      <div class="overview-bar">
        <div class="overview-item"><div class="ov-label">用户ID</div><div class="ov-value mono">{{ detail.customerNo }}</div></div>
        <div class="overview-item"><div class="ov-label">国籍</div><div class="ov-value">{{ countryLabel(detail.countryCode) }}</div></div>
        <div class="overview-item"><div class="ov-label">身份认证</div>
          <!-- 未认证(1)与已认证(3)同为绿色，与右侧「银行认证」的未认证取色保持一致；审核中=橙、已拒绝=红 -->
          <div class="ov-value" :class="(detail.docStatus===3||detail.docStatus===1)?'green':detail.docStatus===2?'orange':'red'">{{ docStatusLabel(detail.docStatus) }}</div></div>
        <div class="overview-item"><div class="ov-label">银行认证</div><div class="ov-value green">{{ detail.bankCards && detail.bankCards.length > 0 ? '已认证' : '未认证' }}</div></div>
        <div class="overview-item"><div class="ov-label">账号状态</div>
          <div class="ov-value" :class="detail.status===1?'green':detail.status===4?'red':'orange'">{{ statusLabel(detail.status) }}</div></div>
        <div class="overview-item"><div class="ov-label">激活状态</div>
          <div class="ov-value" :class="detail.isActive===2?'green':'gray'">{{ detail.isActive===2?'已激活':'未激活' }}</div></div>
        <div class="overview-item"><div class="ov-label">激活时间</div><div class="ov-value">{{ detail.activateTime || '-' }}</div></div>
        <div class="overview-item"><div class="ov-label">客户组别</div><div class="ov-value">{{ groupLabel(detail.groupId) }}</div></div>
        <div class="overview-item"><div class="ov-label">注册时间</div><div class="ov-value">{{ detail.regTime }}</div></div>
      </div>
      <div class="detail-section">
        <div class="detail-section-title">资金信息</div>
        <div class="detail-grid">
          <div class="detail-item"><div class="di-label">资金账户余额</div><div class="di-value">{{ (detail.balance||0).toFixed(2) }}</div></div>
          <div class="detail-item"><div class="di-label">净值</div><div class="di-value">{{ (detail.equity||0).toFixed(2) }}</div></div>
          <div class="detail-item"><div class="di-label">可用保证金</div><div class="di-value">{{ (detail.marginFree || 0).toFixed(2) }}</div></div>
          <div class="detail-item"><div class="di-label">占用保证金</div><div class="di-value">{{ (detail.marginInitial || 0).toFixed(2) }}</div></div>
          <div class="detail-item"><div class="di-label">浮动盈亏</div>
            <div class="di-value" :style="{color:(detail.floatingPl||0)>=0?'#16a34a':'#dc2626'}">{{ (detail.floatingPl||0)>=0?'+':'' }}{{ (detail.floatingPl||0).toFixed(2) }}</div></div>
          <div class="detail-item"><div class="di-label">累计充值</div><div class="di-value">{{ (detail.totalDeposit||0).toFixed(2) }}</div></div>
          <div class="detail-item"><div class="di-label">累计提现</div><div class="di-value">{{ (detail.totalWithdrawal||0).toFixed(2) }}</div></div>
        </div>
      </div>
      <div class="detail-section">
        <div style="display:flex;gap:0;margin-bottom:12px;">
          <button class="tab-btn" :class="{active:detailTab==='basic'}" @click="detailTab='basic'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">客户信息</button>
          <button class="tab-btn" :class="{active:detailTab==='idCard'}" @click="detailTab='idCard'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">证件信息</button>
          <button class="tab-btn" :class="{active:detailTab==='survey'}" @click="detailTab='survey'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">问卷调查</button>
          <button class="tab-btn" :class="{active:detailTab==='bank'}" @click="detailTab='bank'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">银行卡</button>
          <button class="tab-btn" :class="{active:detailTab==='wallet'}" @click="detailTab='wallet'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">电子钱包</button>
          <button class="tab-btn" :class="{active:detailTab==='permission'}" @click="detailTab='permission'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">权限设置</button>
          <button class="tab-btn" :class="{active:detailTab==='events'}" @click="detailTab='events'" style="padding:6px 12px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">事件日志</button>
        </div>
        <!-- 客户信息 Tab -->
        <div v-show="detailTab==='basic'">
          <div class="detail-section-title" style="margin-bottom:8px;">基本信息</div>
          <div class="detail-grid">
            <div class="detail-item"><div class="di-label">头像</div><div class="di-value"><div class="avatar-circle" style="width:40px;height:40px;font-size:16px;">{{ (detail.name||'?')[0] }}</div></div></div>
            <div class="detail-item"><div class="di-label">昵称</div><div class="di-value">{{ detail.nickName || (detail.name||'') + '的昵称' }}</div></div>
            <div class="detail-item"><div class="di-label">用户ID</div><div class="di-value mono">{{ detail.customerNo }}</div></div>
            <div class="detail-item"><div class="di-label">姓名</div><div class="di-value">{{ detail.name }}</div></div>
            <div class="detail-item"><div class="di-label">手机号</div><div class="di-value">{{ (detail.phonePrefix ? '+' + detail.phonePrefix + ' ' : '') + (detail.phoneNumber || '') }}</div></div>
            <div class="detail-item"><div class="di-label">手机归属地</div><div class="di-value">{{ detail.phoneRegion || '-' }}</div></div>
            <div class="detail-item"><div class="di-label">邮箱</div><div class="di-value">{{ detail.email }}</div></div>
            <div class="detail-item"><div class="di-label">出生国家</div><div class="di-value">{{ countryLabel(detail.birthCountry) }}</div></div>
            <div class="detail-item"><div class="di-label">国籍</div><div class="di-value">{{ countryLabel(detail.nationality) }}</div></div>
            <div class="detail-item"><div class="di-label">居住国家</div><div class="di-value">{{ countryLabel(detail.residenceCountry) }}</div></div>
            <div class="detail-item"><div class="di-label">税务居民地</div><div class="di-value">{{ detail.taxResidence || '-' }}</div></div>
            <div class="detail-item"><div class="di-label">税务识别号</div><div class="di-value">{{ detail.tinNumber || '-' }}</div></div>
          </div>
          <div class="detail-section-title" style="margin-top:16px;margin-bottom:8px;">注册/登录信息</div>
          <div class="detail-grid">
            <div class="detail-item"><div class="di-label">注册时间</div><div class="di-value">{{ detail.regTime }}</div></div>
            <div class="detail-item"><div class="di-label">激活时间</div><div class="di-value">{{ detail.activateTime || '-' }}</div></div>
            <div class="detail-item"><div class="di-label">注册IP</div><div class="di-value">{{ detail.regIp || '-' }}</div></div>
            <div class="detail-item"><div class="di-label">开户来源</div><div class="di-value">{{ regLabel(detail.regWay) }}</div></div>
            <div class="detail-item"><div class="di-label">渠道</div><div class="di-value">{{ detail.channel || '-' }}</div></div>
            <div class="detail-item"><div class="di-label">邀请人</div><div class="di-value">{{ detail.referrer || '-' }}</div></div>
            <div class="detail-item"><div class="di-label">最后登录时间</div><div class="di-value">{{ detail.lastLoginTime || '-' }}</div></div>
            <div class="detail-item"><div class="di-label">最后登录IP</div><div class="di-value">{{ detail.lastLoginIp || '-' }}</div></div>
            <div class="detail-item"><div class="di-label">登录次数</div><div class="di-value">{{ detail.loginCount || 0 }}</div></div>
          </div>
        </div>
        <!-- 地址信息（原型1:1） -->
        <template v-if="detailTab==='basic'">
          <div class="detail-section-title" style="margin-top:16px;margin-bottom:8px;">地址信息</div>
          <div class="detail-grid">
            <div class="detail-item"><div class="di-label">居住地址</div><div class="di-value">{{ areaLabel(detail.addresses&&detail.addresses[0]) }}</div></div>
            <div class="detail-item"><div class="di-label">地址证明类型</div><div class="di-value">{{ proofTypeLabel(detail.addresses&&detail.addresses[0]&&detail.addresses[0].proofType) || '--' }}</div></div>
            <div class="detail-item"><div class="di-label">提交时间</div><div class="di-value">{{ (detail.addresses&&detail.addresses[0]&&detail.addresses[0].createDate) || detail.regTime || '--' }}</div></div>
          </div>
          <div style="margin-top:12px;display:flex;gap:16px;">
            <div style="width:120px;text-align:center;">
              <div style="width:120px;height:80px;border:1px solid #d1d9e6;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#9ca3af;font-size:20px;background:#f4f6fb;margin-bottom:6px;overflow:hidden;">
                <img v-if="detail.addresses&&detail.addresses[0]&&detail.addresses[0].proofFileUrls" :src="detail.addresses[0].proofFileUrls" style="width:100%;height:100%;object-fit:cover;">
                <span v-else>📄</span>
              </div>
              <div style="font-size:11px;color:#9ca3af;">地址证明文件</div>
            </div>
          </div>
        </template>

        <!-- 证件信息 Tab -->
        <div v-show="detailTab==='idCard'">
          <div class="detail-grid">
            <div class="detail-item"><div class="di-label">证件类型</div><div class="di-value">{{ docTypeLabel(detail.docType) }}</div></div>
            <div class="detail-item"><div class="di-label">证件号码</div><div class="di-value mono">{{ detail.docNumber || '--' }}</div></div>
            <div class="detail-item"><div class="di-label">证件姓名</div><div class="di-value">{{ detail.docName || detail.name || '--' }}</div></div>
            <div class="detail-item"><div class="di-label">证件国籍</div><div class="di-value">{{ countryLabel(detail.docNationality) }}</div></div>
            <div class="detail-item"><div class="di-label">证件归属地</div><div class="di-value">{{ detail.idCardRegion || '--' }}</div></div>
            <div class="detail-item"><div class="di-label">有效期</div><div class="di-value">{{ detail.validFrom || '--' }} 至 {{ detail.validTo || '--' }}</div></div>
            <div class="detail-item"><div class="di-label">认证状态</div>
              <div class="di-value" :style="{color:detail.docStatus===3?'#16a34a':'#e6a817'}">{{ docStatusLabel(detail.docStatus) }}</div></div>
            <div class="detail-item"><div class="di-label">提交时间</div><div class="di-value">{{ detail.docSubmitTime || detail.regTime || '--' }}</div></div>
            <div class="detail-item"><div class="di-label">审核时间</div><div class="di-value">{{ detail.docReviewTime || detail.activateTime || '--' }}</div></div>
          </div>
          <div style="margin-top:16px;display:flex;gap:16px;">
            <div class="doc-upload-item" v-for="(item,idx) in [{label:'证件正面',icon:'🪪',url:detail.frontImageUrl},{label:'证件反面',icon:'🪪',url:detail.backImageUrl},{label:'手持证件',icon:'👤',url:detail.handheldImageUrl}]" :key="idx">
              <div style="width:120px;height:80px;border:1px solid #d1d9e6;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#9ca3af;background:#f4f6fb;overflow:hidden;">
                <img v-if="item.url" :src="item.url" style="width:100%;height:100%;object-fit:cover;">
                <span v-else style="font-size:20px;">{{ item.icon }}</span>
              </div>
              <div style="font-size:11px;color:#9ca3af;margin-top:4px;text-align:center;">{{ item.label }}</div>
            </div>
          </div>
        </div>
        <!-- 问卷调查 Tab -->
        <div v-show="detailTab==='survey'">
          <div v-if="surveyAnswer && surveyAnswer.answersJson" style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;">
            <div style="display:flex;align-items:center;gap:10px;">
              <div style="width:40px;height:40px;border-radius:8px;background:linear-gradient(135deg,rgba(0,137,123,0.12),rgba(0,137,123,0.06));display:flex;align-items:center;justify-content:center;font-size:20px;">📋</div>
              <div>
                <div style="font-size:14px;font-weight:600;color:#1a2236;">通用模版问卷</div>
                <div style="font-size:12px;color:#9ca3af;margin-top:2px;">已完成</div>
              </div>
            </div>
            <el-button type="primary" size="small" @click="openSurveyResult">查看问卷结果</el-button>
          </div>
          <div v-if="surveyAnswer && surveyAnswer.answersJson" class="detail-grid" style="grid-template-columns:1fr 1fr;">
            <div class="detail-item"><div class="di-label">问卷模板</div><div class="di-value">通用模版问卷</div></div>
            <div class="detail-item"><div class="di-label">问卷版本</div><div class="di-value">{{ surveyAnswer.surveyVersion || 'v1.0' }}</div></div>
            <div class="detail-item"><div class="di-label">完成时间</div><div class="di-value">{{ surveyAnswer.completeTime || '--' }}</div></div>
            <div class="detail-item"><div class="di-label">得分</div><div class="di-value" style="font-weight:600;color:#00897b;">{{ surveyAnswer.totalScore || 0 }}分</div></div>
            <div class="detail-item"><div class="di-label">风险等级</div><div class="di-value"><span style="background:rgba(0,137,123,0.12);color:#00897b;font-size:11px;padding:2px 8px;border-radius:4px;">{{ surveyAnswer.riskLevel || '--' }}</span></div></div>
            <div class="detail-item"><div class="di-label">关键题结果</div><div class="di-value">{{ surveyAnswer.keyResult || '--' }}</div></div>
          </div>
          <div v-else style="text-align:center;padding:40px;color:#9ca3af;font-size:13px;">暂无问卷记录</div>
        </div>

        <!-- 银行卡 Tab -->
        <div v-show="detailTab==='bank'">
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
            <div v-for="card in (detail.bankCards||[])" :key="card.id" style="border:1px solid #e8ecf2;border-radius:10px;padding:16px;background:#f4f6fb;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
                <div style="font-size:14px;font-weight:600;color:#1a2236;">{{ card.bankName }}</div>
                <span style="background:rgba(22,163,74,0.12);color:#16a34a;font-size:11px;padding:2px 8px;border-radius:4px;">{{ verifyStatusLabel(card.status) }}</span>
              </div>
              <div class="mono" style="font-size:13px;color:#1a2236;margin-bottom:8px;letter-spacing:1px;">{{ card.bankAccount }}</div>
              <div style="font-size:11px;color:#9ca3af;margin-bottom:4px;">持卡人：{{ card.bankHolder }}</div>
              <div style="font-size:11px;color:#9ca3af;margin-bottom:4px;">{{ card.branch || '--' }} · {{ card.countryCode || '--' }}</div>
              <div style="font-size:11px;color:#606266;margin-bottom:2px;"><span v-if="card.bankCode">银行编码: {{ card.bankCode }}</span><span v-if="card.bankCode&&card.bankSwift" style="margin:0 8px;">|</span><span v-if="card.bankSwift">SWIFT: {{ card.bankSwift }}</span><span v-if="card.bankSwift&&card.bankIban" style="margin:0 8px;">|</span><span v-if="card.bankIban">IBAN: {{ card.bankIban }}</span></div>
              <div style="font-size:11px;color:#606266;margin-bottom:4px;" v-if="card.bankSortCode">Sort Code: {{ card.bankSortCode }}</div>
              <div style="font-size:11px;color:#9ca3af;">绑定时间：{{ card.bindTime || '--' }}</div>
            </div>
            <div v-if="!(detail.bankCards||[]).length" style="grid-column:span 2;text-align:center;padding:40px;color:#9ca3af;font-size:13px;">暂无银行卡记录</div>
          </div>
        </div>
        <!-- 电子钱包 Tab -->
        <div v-show="detailTab==='wallet'">
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
            <div v-for="w in (detail.wallets||[])" :key="w.id" style="border:1px solid #e8ecf2;border-radius:10px;padding:16px;background:#f4f6fb;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
                <div style="font-size:14px;font-weight:600;color:#1a2236;">{{ walletTypeLabel(w.walletType) }}</div>
                <span style="background:rgba(22,163,74,0.12);color:#16a34a;font-size:11px;padding:2px 8px;border-radius:4px;">{{ verifyStatusLabel(w.status) }}</span>
              </div>
              <div class="mono" style="font-size:11px;color:#1a2236;margin-bottom:8px;word-break:break-all;">{{ w.address }}</div>
              <div style="font-size:11px;color:#9ca3af;margin-bottom:4px;">持有人：{{ w.holder }}</div>
              <div style="font-size:11px;color:#9ca3af;">绑定时间：{{ w.bindTime || '--' }}</div>
            </div>
            <div v-if="!(detail.wallets||[]).length" style="grid-column:span 2;text-align:center;padding:40px;color:#9ca3af;font-size:13px;">暂无电子钱包记录</div>
          </div>
        </div>
        <!-- 权限设置 Tab (只读) -->
        <div v-show="detailTab==='permission'">
          <div class="detail-grid">
            <div class="detail-item"><div class="di-label">入金权限</div><div class="di-value" :style="{color:permVal('deposit')===1?'#16a34a':'#dc2626'}">{{ permVal('deposit')===1?'允许':'禁止' }}</div></div>
            <div class="detail-item"><div class="di-label">出金权限</div><div class="di-value" :style="{color:permVal('withdraw')===1?'#16a34a':'#dc2626'}">{{ permVal('withdraw')===1?'允许':'禁止' }}</div></div>
            <div class="detail-item"><div class="di-label">开仓权限</div><div class="di-value" :style="{color:permVal('allowOpen')===1?'#16a34a':'#dc2626'}">{{ permVal('allowOpen')===1?'允许':'禁止' }}</div></div>
            <div class="detail-item"><div class="di-label">平仓权限</div><div class="di-value" :style="{color:permVal('allowClose')===1?'#16a34a':'#dc2626'}">{{ permVal('allowClose')===1?'允许':'禁止' }}</div></div>
            <div class="detail-item"><div class="di-label">转账权限</div><div class="di-value" :style="{color:permVal('internalTransfer')===1?'#16a34a':'#dc2626'}">{{ permVal('internalTransfer')===1?'允许':'禁止' }}</div></div>
          </div>
        </div>
        <!-- 事件日志 Tab -->
        <div v-show="detailTab==='events'">
          <div style="display:flex;gap:10px;margin-bottom:12px;align-items:center;flex-wrap:wrap;">
            <el-select v-model="eventFilter.type" placeholder="全部事件类型" size="small" style="width:140px;" clearable @change="onEventSearch">
              <el-option v-for="t in eventTypes" :key="t.code" :label="t.label" :value="t.code"></el-option>
            </el-select>
            <el-input v-model="eventFilter.operator" placeholder="操作人" size="small" style="width:120px;" clearable @input="onEventSearch"></el-input>
            <el-input v-model="eventFilter.orderNo" placeholder="订单号" size="small" style="width:160px;" clearable @input="onEventSearch"></el-input>
            <el-date-picker v-model="eventFilter.timeRange" type="datetimerange" range-separator="至" start-placeholder="开始" end-placeholder="结束" value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width:360px;" @change="onEventSearch"></el-date-picker>
            <el-button type="primary" size="small" @click="onEventSearch">搜索</el-button>
            <el-button size="small" @click="resetEventFilter">重置</el-button>
          </div>
          <el-table :data="eventLogs||[]" border size="small" style="font-size:13px;">
            <el-table-column prop="orderNo" label="订单号" width="180"></el-table-column>
            <el-table-column label="事件类型" width="110">
              <template slot-scope="{row}"><el-tag :type="eventTypeColor(row.eventType)" size="mini">{{ eventTypeLabel(row.eventType) }}</el-tag></template>
            </el-table-column>
            <el-table-column label="事件内容">
              <template slot-scope="{row}">
                <span :title="formatEventContent(row.content)" style="cursor:pointer;color:var(--brand-primary);display:inline-block;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" @click="openEventDetail(row)">{{ formatEventContent(row.content) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="operateTime" label="时间" width="160"></el-table-column>
            <el-table-column prop="operator" label="操作人" width="100"></el-table-column>
          </el-table>
          <el-pagination v-if="eventTotal > 0" @current-change="(v)=>{eventPageNum=v;fetchEvents()}" :current-page="eventPageNum" :page-size="eventPageSize" layout="total,prev,pager,next" :total="eventTotal" style="margin-top:10px;text-align:right;"></el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 事件变更对比弹窗 -->
    <el-dialog :visible.sync="eventDetailVisible" width="640px" :close-on-click-modal="false">
      <div slot="title"><h3 style="margin:0;">变更对比</h3></div>
      <div v-if="eventDetailChanges && eventDetailChanges.length" style="font-size:13px;">
        <div style="margin-bottom:10px;color:#5a6578;font-size:12px;">{{ eventDetailEntityType }} 共修改 {{ eventDetailChanges.length }} 个字段</div>
        <el-table :data="eventDetailChanges" border size="small">
          <el-table-column prop="label" label="字段" width="140"></el-table-column>
          <el-table-column label="修改前">
            <template slot-scope="{row}"><span style="color:#dc2626;">{{ row.old || '（空）' }}</span></template>
          </el-table-column>
          <el-table-column label="修改后">
            <template slot-scope="{row}"><span style="color:#16a34a;">{{ row.new || '（空）' }}</span></template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else style="text-align:center;padding:30px;color:#9ca3af;">无变更明细</div>
      <div slot="footer"><el-button type="primary" @click="eventDetailVisible=false">关闭</el-button></div>
    </el-dialog>

    <!-- 问卷结果弹窗 -->
    <el-dialog :visible.sync="surveyResultVisible" width="880px" :close-on-click-modal="false">
      <div slot="title"><h3 style="margin:0;">问卷结果 - 通用模版问卷</h3></div>
      <div style="padding:8px 0;max-height:65vh;overflow-y:auto;">
        <div v-for="(sec, si) in surveySections" :key="si" style="margin-bottom:16px;">
          <div style="font-size:13px;font-weight:600;color:#1a2236;margin-bottom:10px;padding:6px 10px;background:#f4f6fb;border-radius:6px;">
            第{{ si+1 }}部分 · {{ sec.sectionName }}（{{ sec.scoringEnabled === 1 ? '计分' : '不计分' }}）
          </div>
          <div v-for="(q, qi) in (sec.questions||[])" :key="qi" style="margin-bottom:8px;padding:8px 12px;background:#fff;border:1px solid #e8ecf2;border-radius:6px;">
            <div style="color:#5a6578;font-size:12px;">
              Q{{ qi+1 }}. {{ q.questionText }}
              <el-tag v-if="q.isKey === 1" type="warning" size="mini" style="margin-left:6px;">关键题</el-tag>
            </div>
            <div style="display:flex;justify-content:space-between;align-items:center;margin-top:4px;">
              <span style="font-weight:500;font-size:13px;color:#1a2236;">{{ q.answer || '--' }}</span>
              <span v-if="q.score != null" style="color:#00897b;font-size:12px;font-weight:600;">+{{ q.score }}分</span>
            </div>
          </div>
        </div>
        <div v-if="!surveySections.length" style="text-align:center;padding:40px;color:#9ca3af;">暂无答题详情</div>
      </div>
      <div slot="footer"><el-button type="primary" @click="surveyResultVisible=false">关闭</el-button></div>
    </el-dialog>

    <!-- 子账户编辑弹窗 -->
    <el-dialog :visible.sync="subEditVisible" width="720px" :close-on-click-modal="false">
      <div slot="title"><h3 style="margin:0;">编辑账户</h3></div>
      <div class="edit-section">
        <div class="edit-section-title">基本信息</div>
        <div class="detail-grid">
          <div class="detail-item"><div class="di-label">交易账号</div><div class="di-value mono">{{ subEdit.login }}</div></div>
          <div class="detail-item"><div class="di-label">所属用户</div><div class="di-value">{{ subEdit.userName }}</div></div>
          <div class="detail-item"><div class="di-label">交易平台</div><div class="di-value">MT5</div></div>
          <div class="detail-item"><div class="di-label">状态</div><div class="di-value"><el-tag :type="subEdit.status===1?'success':'danger'" size="mini">{{ subEdit.status===1?'正常':'禁用' }}</el-tag></div></div>
        </div>
        <div class="edit-form-group" style="margin-top:16px;" v-if="subEdit.accountType !== 1">
          <label>交易组设置 <span style="color:#9ca3af;font-weight:400;">（不同交易组具有不同的点差、佣金等配置。）</span></label>
          <el-select v-model="subEdit.tradeGroupName" style="width:400px;" filterable allow-create default-first-option placeholder="请选择或输入交易组">
            <el-option v-for="g in subEdit.groupOptions" :key="g" :label="g" :value="g"></el-option>
          </el-select>
        </div>
        <div class="edit-form-group" style="margin-top:16px;" v-if="subEdit.accountType !== 1">
          <label>预付款杠杆 <span style="color:#9ca3af;font-weight:400;">（1:N 中的 N，如 100 表示 1:100；仅真实/模拟账户可改，留空表示不修改。⚠ 仅记录到本系统账户资料，不同步修改 MT5 账户的实际杠杆。）</span></label>
          <el-input v-model="subEdit.marginLeverage" style="width:400px;" placeholder="请输入预付款杠杆"></el-input>
        </div>
      </div>
      <div class="edit-section">
        <div class="edit-section-title">账户权限设置</div>
        <div style="display:grid;grid-template-columns:1fr;gap:10px;">
          <div class="perm-card">
            <div class="perm-icon green">⇄</div>
            <div class="perm-info"><div class="perm-title">内部转账</div><div class="perm-desc">允许账户间资金划转</div></div>
            <el-switch v-model="subEdit.internalTransfer" :active-value="1" :inactive-value="2" :disabled="subEdit.accountType===3"></el-switch>
          </div>
          <div class="perm-card">
            <div class="perm-icon blue">📈</div>
            <div class="perm-info"><div class="perm-title">允许开仓</div><div class="perm-desc">允许客户开立新仓位</div></div>
            <el-switch v-model="subEdit.allowOpen" :active-value="1" :inactive-value="2"></el-switch>
          </div>
          <div class="perm-card">
            <div class="perm-icon orange">📉</div>
            <div class="perm-info"><div class="perm-title">允许平仓</div><div class="perm-desc">允许客户平仓现有仓位</div></div>
            <el-switch v-model="subEdit.allowClose" :active-value="1" :inactive-value="2"></el-switch>
          </div>
          <div class="perm-card">
            <div class="perm-icon red">💰</div>
            <div class="perm-info"><div class="perm-title">出金权限</div><div class="perm-desc">允许客户提取资金</div></div>
            <el-switch v-model="subEdit.withdraw" :active-value="1" :inactive-value="2"></el-switch>
          </div>
          <div class="perm-card">
            <div class="perm-icon cyan">💳</div>
            <div class="perm-info"><div class="perm-title">入金权限</div><div class="perm-desc">允许客户充值资金</div></div>
            <el-switch v-model="subEdit.deposit" :active-value="1" :inactive-value="2"></el-switch>
          </div>
        </div>
        <div style="margin-top:12px;padding:10px 12px;background:#fef7e6;border-radius:6px;color:#b45309;font-size:12px;">⚠ 关闭所有权限将自动锁定账户；不会修改交易已经在进行中的订单。</div>
      </div>
      <div slot="footer">
        <el-button @click="subEditVisible=false">取消</el-button>
        <el-button v-auth="'business:clientAccount:edit'" type="primary" @click="saveSubAccountEdit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 子账户详情弹窗 -->
    <el-dialog :visible.sync="subDetailVisible" width="1150px" :close-on-click-modal="false" top="5vh">
      <div slot="title"><h3 style="margin:0;">交易账号详情</h3></div>
      <div v-if="subDetail" style="max-height:72vh;overflow-y:auto;">
        <div class="overview-bar">
          <div class="overview-item"><div class="ov-label">用户ID</div><div class="ov-value mono">{{ subDetail.customerNo }}</div></div>
          <div class="overview-item"><div class="ov-label">交易账号</div><div class="ov-value mono">{{ subDetail.accountNo }}</div></div>
          <div class="overview-item"><div class="ov-label">账户类型</div><div class="ov-value">{{ subAccountTypeLabel(subDetail.accountType) }}</div></div>
          <div class="overview-item"><div class="ov-label">交易账户组</div><div class="ov-value mono">{{ subDetail.tradeGroupName || '-' }}</div></div>
          <div class="overview-item"><div class="ov-label">账号状态</div><div class="ov-value green">{{ subDetail.status===1?'正常':'禁用' }}</div></div>
          <div class="overview-item"><div class="ov-label">所属用户</div><div class="ov-value">{{ subDetail.userName }}</div></div>
          <div class="overview-item"><div class="ov-label">创建时间</div><div class="ov-value">{{ subDetail.regTime }}</div></div>
        </div>

        <div class="detail-section">
          <div class="detail-section-title">资金信息</div>
          <div class="detail-grid">
            <div class="detail-item"><div class="di-label">账户余额</div><div class="di-value">{{ (subDetail.balance||0).toFixed(2) }}</div></div>
            <div class="detail-item"><div class="di-label">净值</div><div class="di-value">{{ (subDetail.equity||0).toFixed(2) }}</div></div>
            <div class="detail-item"><div class="di-label">可用保证金</div><div class="di-value">{{ (subDetail.marginFree||0).toFixed(2) }}</div></div>
            <div class="detail-item"><div class="di-label">占用保证金</div><div class="di-value">{{ (subDetail.marginInitial||0).toFixed(2) }}</div></div>
            <div class="detail-item"><div class="di-label">浮动盈亏</div><div class="di-value" :style="{color:(subDetail.floatingPl||0)>=0?'#16a34a':'#dc2626'}">{{ (subDetail.floatingPl||0)>=0?'+':'' }}{{ (subDetail.floatingPl||0).toFixed(2) }}</div></div>
          </div>
        </div>

        <div class="detail-section">
          <div style="display:flex;gap:0;margin-bottom:12px;">
            <button v-if="subDetail.accountType !== 1" class="tab-btn" :class="{active:subDetailTab==='positions'}" @click="switchSubDetailTab('positions')" style="padding:6px 14px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">持仓记录（{{ posTotal }}）</button>
            <button v-if="subDetail.accountType !== 1" class="tab-btn" :class="{active:subDetailTab==='orders'}" @click="switchSubDetailTab('orders')" style="padding:6px 14px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">委托记录（{{ orderTotal }}）</button>
            <button v-if="subDetail.accountType !== 1" class="tab-btn" :class="{active:subDetailTab==='deals'}" @click="switchSubDetailTab('deals')" style="padding:6px 14px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">交易历史（{{ dealTotal }}）</button>
            <button v-if="subDetail.accountType !== 3" class="tab-btn" :class="{active:subDetailTab==='fund'}" @click="switchSubDetailTab('fund')" style="padding:6px 14px;font-size:12px;border:1px solid #d1d9e6;background:#fff;cursor:pointer;">资金流水（{{ ffTotal }}）</button>
          </div>

          <!-- 持仓记录 -->
          <div v-show="subDetailTab==='positions' && subDetail.accountType !== 1">
            <el-form :inline="true" size="small">
              <el-form-item label="持仓单号"><el-input v-model="posSearch.position" placeholder="持仓单号" clearable style="width:130px;"></el-input></el-form-item>
              <el-form-item label="交易品种"><el-input v-model="posSearch.symbol" placeholder="交易品种" clearable style="width:110px;"></el-input></el-form-item>
              <el-form-item label="方向">
                <el-select v-model="posSearch.action" placeholder="全部方向" clearable style="width:100px;">
                  <el-option label="买入" :value="0"></el-option><el-option label="卖出" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item><el-button type="primary" @click="searchPositions">搜索</el-button><el-button @click="resetPositions">重置</el-button></el-form-item>
            </el-form>
            <el-table :data="posList" border size="small" v-loading="posLoading" style="font-size:13px;">
              <el-table-column prop="position" label="持仓单号" width="90"></el-table-column>
              <el-table-column prop="symbol" label="交易品种" width="90"></el-table-column>
              <el-table-column label="方向" width="70"><template slot-scope="{row}"><span :style="{color:row.action===0?'#16a34a':'#dc2626'}">{{ row.action===0?'买入':'卖出' }}</span></template></el-table-column>
              <el-table-column label="手数" width="80"><template slot-scope="{row}">{{ volumeToLots(row.volume) }}</template></el-table-column>
              <el-table-column label="开仓价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceOpen, row.digits) }}</template></el-table-column>
              <el-table-column label="最新价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceCurrent, row.digits) }}</template></el-table-column>
              <el-table-column label="止损" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceSL, row.digits) }}</template></el-table-column>
              <el-table-column label="止盈" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceTP, row.digits) }}</template></el-table-column>
              <el-table-column label="手续费(USD)" width="90"><template slot-scope="{row}">{{ (row.commission||0).toFixed(2) }}</template></el-table-column>
              <el-table-column prop="storage" label="利息(USD)" width="90"></el-table-column>
              <el-table-column label="浮动盈亏(USD)" width="120"><template slot-scope="{row}"><span :style="{color:(row.profit||0)>=0?'#16a34a':'#dc2626'}">{{ (row.profit||0)>=0?'+':'' }}{{ (row.profit||0).toFixed(2) }}</span></template></el-table-column>
              <el-table-column label="占用保证金(USD)" width="110"><template slot-scope="{row}">{{ (row.margin||0).toFixed(2) }}</template></el-table-column>
              <el-table-column label="开仓时间" width="160"><template slot-scope="{row}">{{ fmtGmt8(row.timeCreate) }}</template></el-table-column>
              <el-table-column prop="comment" label="订单注释" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column label="操作" width="70" fixed="right"><template slot-scope="{row}"><el-button v-auth="'business:clientAccount:close'" type="text" size="small" style="color:#f56c6c;" @click="closePosition(row)">平仓</el-button></template></el-table-column>
            </el-table>
            <el-pagination v-if="posTotal > 0" @size-change="(v)=>{posPageSize=v;posPageNum=1;fetchSubPositions()}" @current-change="(v)=>{posPageNum=v;fetchSubPositions()}" :current-page="posPageNum" :page-sizes="[15,30,50]" :page-size="posPageSize" layout="total,sizes,prev,pager,next" :total="posTotal" style="margin-top:10px;text-align:right;"></el-pagination>
          </div>

          <!-- 委托记录 -->
          <div v-show="subDetailTab==='orders' && subDetail.accountType !== 1">
            <el-form :inline="true" size="small">
              <el-form-item label="委托单号"><el-input v-model="orderSearch.order" placeholder="委托单号" clearable style="width:130px;"></el-input></el-form-item>
              <el-form-item label="交易品种"><el-input v-model="orderSearch.symbol" placeholder="交易品种" clearable style="width:110px;"></el-input></el-form-item>
              <el-form-item label="委托类型">
                <el-select v-model="orderSearch.type" placeholder="全部类型" clearable style="width:120px;">
                  <el-option label="买入" :value="0"></el-option><el-option label="卖出" :value="1"></el-option>
                  <el-option label="买入限价" :value="2"></el-option><el-option label="卖出限价" :value="3"></el-option>
                  <el-option label="买入止损" :value="4"></el-option><el-option label="卖出止损" :value="5"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item><el-button type="primary" @click="searchOrders">搜索</el-button><el-button @click="resetOrders">重置</el-button></el-form-item>
            </el-form>
            <el-table :data="orderList" border size="small" v-loading="orderLoading" style="font-size:13px;">
              <el-table-column prop="order" label="委托单号" width="100"></el-table-column>
              <el-table-column prop="symbol" label="交易品种" width="90"></el-table-column>
              <el-table-column label="方向" width="70"><template slot-scope="{row}"><span :style="{color:orderDirectionLabel(row.type)==='买入'?'#16a34a':'#dc2626'}">{{ orderDirectionLabel(row.type) }}</span></template></el-table-column>
              <el-table-column label="委托类型" width="100"><template slot-scope="{row}">{{ orderTypeLabel(row.type) }}</template></el-table-column>
              <el-table-column label="手数" width="80"><template slot-scope="{row}">{{ volumeToLots(row.volumeInitial) }}</template></el-table-column>
              <el-table-column label="挂单价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceOrder, row.digits) }}</template></el-table-column>
              <el-table-column label="最新价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceCurrent, row.digits) }}</template></el-table-column>
              <el-table-column label="止损" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceSL, row.digits) }}</template></el-table-column>
              <el-table-column label="止盈" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceTP, row.digits) }}</template></el-table-column>
              <el-table-column label="有效期" width="200" show-overflow-tooltip><template slot-scope="{row}">{{ orderTimeTypeLabel(row.typeTime, row.timeExpiration) }}</template></el-table-column>
              <el-table-column label="挂单时间" width="160"><template slot-scope="{row}">{{ fmtGmt8(row.timeSetup) }}</template></el-table-column>
              <el-table-column label="状态" width="100"><template slot-scope="{row}"><el-tag :type="orderStateType(row.state)" size="mini">{{ orderStateLabel(row.state) }}</el-tag></template></el-table-column>
              <el-table-column label="操作" width="70" fixed="right"><template slot-scope="{row}"><el-button v-auth="'business:clientAccount:cancel'" type="text" size="small" style="color:#f56c6c;" @click="cancelOrder(row)">撤单</el-button></template></el-table-column>
            </el-table>
            <el-pagination v-if="orderTotal > 0" @size-change="(v)=>{orderPageSize=v;orderPageNum=1;fetchSubOrders()}" @current-change="(v)=>{orderPageNum=v;fetchSubOrders()}" :current-page="orderPageNum" :page-sizes="[15,30,50]" :page-size="orderPageSize" layout="total,sizes,prev,pager,next" :total="orderTotal" style="margin-top:10px;text-align:right;"></el-pagination>
          </div>

          <!-- 交易历史 -->
          <div v-show="subDetailTab==='deals' && subDetail.accountType !== 1">
            <el-form :inline="true" size="small">
              <el-form-item label="成交单号"><el-input v-model="dealSearch.deal" placeholder="成交单号" clearable style="width:130px;"></el-input></el-form-item>
              <el-form-item label="交易品种"><el-input v-model="dealSearch.symbol" placeholder="交易品种" clearable style="width:110px;"></el-input></el-form-item>
              <el-form-item label="方向">
                <el-select v-model="dealSearch.action" placeholder="全部方向" clearable style="width:100px;">
                  <el-option label="买入" :value="0"></el-option><el-option label="卖出" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item><el-button type="primary" @click="searchDeals">搜索</el-button><el-button @click="resetDeals">重置</el-button></el-form-item>
            </el-form>
            <el-table :data="dealList" border size="small" v-loading="dealLoading" style="font-size:13px;">
              <el-table-column prop="deal" label="成交单号" width="90"></el-table-column>
              <el-table-column prop="symbol" label="交易品种" width="90"></el-table-column>
              <el-table-column label="交易类型" width="80"><template slot-scope="{row}">{{ dealEntryLabel(row.entry) }}</template></el-table-column>
              <el-table-column label="方向" width="70"><template slot-scope="{row}"><span :style="{color:row.action===0?'#16a34a':'#dc2626'}">{{ row.action===0?'买入':'卖出' }}</span></template></el-table-column>
              <el-table-column label="手数" width="80"><template slot-scope="{row}">{{ volumeToLots(row.volume) }}</template></el-table-column>
              <el-table-column label="开仓价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.openPrice, row.digits) }}</template></el-table-column>
              <el-table-column label="平仓价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.closePrice, row.digits) }}</template></el-table-column>
              <el-table-column prop="commission" label="手续费(USD)" width="100"></el-table-column>
              <el-table-column prop="storage" label="利息(USD)" width="90"></el-table-column>
              <el-table-column label="净盈亏(USD)" width="120"><template slot-scope="{row}"><span :style="{color:(row.profit||0)>=0?'#16a34a':'#dc2626'}">{{ (row.profit||0)>=0?'+':'' }}{{ (row.profit||0).toFixed(2) }}</span></template></el-table-column>
              <el-table-column label="占用保证金(USD)" width="110"><template slot-scope="{row}">{{ (row.margin||0).toFixed(2) }}</template></el-table-column>
              <el-table-column label="开仓时间" width="160"><template slot-scope="{row}">{{ fmtGmt8(row.openTime) }}</template></el-table-column>
              <el-table-column label="成交时间" width="160"><template slot-scope="{row}">{{ fmtGmt8(row.time) }}</template></el-table-column>
            </el-table>
            <el-pagination v-if="dealTotal > 0" @size-change="(v)=>{dealPageSize=v;dealPageNum=1;fetchSubDeals()}" @current-change="(v)=>{dealPageNum=v;fetchSubDeals()}" :current-page="dealPageNum" :page-sizes="[15,30,50]" :page-size="dealPageSize" layout="total,sizes,prev,pager,next" :total="dealTotal" style="margin-top:10px;text-align:right;"></el-pagination>
          </div>

          <!-- 资金流水 -->
          <div v-show="subDetailTab==='fund' && subDetail.accountType !== 3">
            <el-form :inline="true" size="small">
              <el-form-item label="订单号"><el-input v-model="ffSearch.flowNo" placeholder="订单号" clearable style="width:160px;"></el-input></el-form-item>
              <el-form-item label="类型">
                <el-select v-model="ffSearch.subjectType" placeholder="全部类型" clearable style="width:110px;">
                  <el-option v-for="s in subjectOptions" :key="s.code" :label="s.desc" :value="s.code"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="时间">
                <el-date-picker v-model="ffSearch.timeRange" type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" style="width:340px;"></el-date-picker>
              </el-form-item>
              <el-form-item><el-button type="primary" @click="searchFundFlows">搜索</el-button><el-button @click="resetFundFlows">重置</el-button></el-form-item>
            </el-form>
            <el-table :data="ffList" border size="small" v-loading="ffLoading" style="font-size:13px;">
              <el-table-column prop="flowNo" label="订单号" width="180"></el-table-column>
              <el-table-column prop="subjectName" label="类型" width="100"></el-table-column>
              <el-table-column label="金额(USD)" width="120" align="right">
                <template slot-scope="{row}"><span :style="{fontWeight:500,color:(row.balance||0)>0?'#16a34a':(row.balance||0)<0?'#dc2626':'inherit'}">{{ (row.balance||0)>0?'+':'' }}{{ fmtMoney(row.balance) }}</span></template>
              </el-table-column>
              <el-table-column label="余额(USD)" width="120" align="right"><template slot-scope="{row}">{{ fmtMoney(row.balanceAfter) }}</template></el-table-column>
              <el-table-column label="时间" width="170"><template slot-scope="{row}">{{ fmtDateTime(row.createDate) }}</template></el-table-column>
              <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip></el-table-column>
            </el-table>
            <el-pagination v-if="ffTotal > 0" @size-change="(v)=>{ffPageSize=v;ffPageNum=1;fetchSubFundFlows()}" @current-change="(v)=>{ffPageNum=v;fetchSubFundFlows()}" :current-page="ffPageNum" :page-sizes="[15,30,50]" :page-size="ffPageSize" layout="total,sizes,prev,pager,next" :total="ffTotal" style="margin-top:10px;text-align:right;"></el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer"><el-button type="primary" @click="subDetailVisible=false">关闭</el-button></div>
    </el-dialog>
  </div>
</template>

<script>
import { clientAccountList, clientAccountStats, clientAccountDetail, clientAccountSubAccounts, clientAccountAdd, clientAccountBatchAddTag, clientAccountBatchRemoveTag, clientAccountBatchTransferGroup, clientAccountTransferTargets, clientAccountExport, clientAccountEditAccountAll, clientAccountStatus, clientAccountResetPwd, clientAccountUpdateAccount, clientAccountEventLogs, clientAccountSurveyAnswer, clientAccountSubAccountPermissionGet, clientAccountSubAccountEdit, clientAccountSubAccountPositions, clientAccountSubAccountDeals, clientAccountSubAccountOrders, clientAccountSubAccountClosePosition, clientAccountSubAccountCancelOrder, clientAccountSubAccountCounts } from '@/api/clientAccount'
import { customerGroupList } from '@/api/customerGroup'
import { tagListAll } from '@/api/tagManagement'
import { countryList } from '@/api/regConfig'
import { fundFlowList } from '@/api/fundFlow'
import { regionData, codeToText } from 'element-china-area-data'

export default {
  name: 'ClientAccountList',
  data() {
    return {
      stats: {}, tableData: [], loading: false, total: 0,
      pageNum: 1, pageSize: 15, selection: [],
      search: { customerNo: '', name: '', countryCode: '', accountNo: '', phone: '', email: '', groupId: null, status: null, isActive: null, tagId: null, regWay: null, referrer: '', activateDate: null, regDate: null },
      groupOptions: [], tagOptions: [], countries: [],
      addClientVisible: false, addForm: { name: '', phone: '', email: '', groupId: null, tagId: null, referrer: '', remark: '', docType: 1, docNumber: '', docName: '', nationality: '中国', validFrom: '', validTo: '', verifyStatus: 1 },
      docPreviews: [null, null, null],
      addTagVisible: false, batchTag: { userIds: '', selectedTags: [], tip: '' },
      delTagVisible: false, batchDelTag: { userIds: '', tip: '' },
      transferVisible: false, transferForm: { userIds: '', targetGroupId: null, reason: '', tip: '' },
      transferGroupOptions: [], transferCountryCode: '', transferReqSeq: 0,
      editVisible: false, editForm: null, editTab: 'id',
      editIdCard: { docType: 1, docNumber: '', docName: '', nationality: '', validFrom: '', validTo: '', status: 1 },
      editBankCards: [], editWallets: [],
      editAddress: { countryCode: '', address: '', proofType: null, proofFileUrls: '', createDate: '', pca: [] },
      chinaAreaOptions: [],
      detailVisible: false, detail: null, detailTab: 'basic',
      permForm: { customerId: null, deposit: 1, withdraw: 1, allowOpen: 1, allowClose: 1, internalTransfer: 1 },
      subEditVisible: false, subEdit: { accountNo: null, login: '', userName: '', accountType: 2, status: 1, tradeGroupName: '', groupOptions: [], marginLeverage: '', deposit: 1, withdraw: 1, internalTransfer: 1, allowOpen: 1, allowClose: 1 },
      subDetailVisible: false, subDetail: null, subDetailTab: 'positions',
      posLoaded: false, orderLoaded: false, dealLoaded: false,
      posList: [], posLoading: false, posTotal: 0, posPageNum: 1, posPageSize: 15, posSearch: { position: '', symbol: '', action: null },
      dealList: [], dealLoading: false, dealTotal: 0, dealPageNum: 1, dealPageSize: 15, dealSearch: { deal: '', symbol: '', action: null },
      orderList: [], orderLoading: false, orderTotal: 0, orderPageNum: 1, orderPageSize: 15, orderSearch: { order: '', symbol: '', type: null },
      ffList: [], ffLoading: false, ffTotal: 0, ffPageNum: 1, ffPageSize: 15,
      ffSearch: { flowNo: '', subjectType: null, timeRange: null },
      subjectOptions: [
        { code: 1, desc: '存款' }, { code: 2, desc: '人工存款' }, { code: 3, desc: '取款' },
        { code: 4, desc: '转入' }, { code: 5, desc: '转出' }, { code: 6, desc: '开仓佣金' },
        { code: 7, desc: '盈亏' }, { code: 8, desc: '交易编码扣费' }, { code: 9, desc: '交易编码退费' },
        { code: 10, desc: '活动赠金' }, { code: 11, desc: '赠金' }, { code: 12, desc: '奖励送出' },
        { code: 13, desc: '奖励扣回' }, { code: 14, desc: '额度调整' }, { code: 15, desc: '清零' }
      ],
      eventFilter: { type: '', operator: '', orderNo: '', timeRange: null },
      eventLogs: [],
      eventPageNum: 1, eventPageSize: 50, eventTotal: 0,
      eventDetailVisible: false, eventDetailChanges: [], eventDetailEntityType: '',
      surveyAnswer: null, surveyResultVisible: false, surveySections: [],
      eventTypes: [
        { code: 1, label: '权限变更' }, { code: 2, label: '账户激活' }, { code: 3, label: '分组调整' },
        { code: 4, label: '银行卡绑定' }, { code: 5, label: '登录异常' }, { code: 6, label: '入金成功' },
        { code: 7, label: '入金失败' }, { code: 8, label: '提交身份认证' }, { code: 9, label: '身份认证成功' },
        { code: 10, label: '身份认证失败' }, { code: 11, label: '身份认证拒绝' }, { code: 12, label: '出金申请' },
        { code: 13, label: '出金成功' }, { code: 14, label: '出金失败' }, { code: 15, label: '出金拒绝' },
        { code: 16, label: '解绑银行卡' }, { code: 17, label: '修改身份认证资料' }, { code: 18, label: '修改标签' },
        { code: 19, label: '提交电子钱包' }, { code: 20, label: '钱包审核通过' }, { code: 21, label: '解绑电子钱包' },
        { code: 22, label: '绑定手机号' }, { code: 23, label: '绑定邮箱' }, { code: 24, label: '个人信息变更' },
        { code: 25, label: '禁用账户' }, { code: 26, label: '注销账户' }, { code: 27, label: '解锁账户' },
        { code: 28, label: '新增额度调整' }, { code: 29, label: '额度调整审核通过' }, { code: 30, label: '额度调整审核失败' },
        { code: 31, label: '杠杆调整' }
      ],
    }
  },
  computed: {},
  filters: {
    formatMoney(v) { return v != null ? Number(v).toFixed(2) : '0.00' }
  },
  created() { this.fetchStats(); this.fetchList(); this.fetchGroups(); this.fetchTags(); this.fetchCountries(); this.chinaAreaOptions = regionData },
  methods: {
    fetchList() {
      this.loading = true
      const params = { pageNum: this.pageNum, pageSize: this.pageSize, ...this.search }
      if (params.activateDate && params.activateDate.length) { params.activateDateBegin = params.activateDate[0]; params.activateDateEnd = params.activateDate[1] }
      if (params.regDate && params.regDate.length) { params.regDateBegin = params.regDate[0]; params.regDateEnd = params.regDate[1] }
      clientAccountList(params).then(res => {
        if (res.code === 0) { this.tableData = res.result.list || []; this.total = res.result.total || 0 }
      }).finally(() => { this.loading = false })
    },
    fetchStats() { clientAccountStats().then(res => { if (res.code === 0) this.stats = res.result || {} }) },
    fetchGroups() { customerGroupList({ pageNum: 1, pageSize: 500 }).then(res => { if (res.code === 0) this.groupOptions = res.result.list || [] }) },
    fetchTags() { tagListAll().then(res => { if (res.code === 0) this.tagOptions = res.result || [] }) },
    fetchCountries() { countryList({ pageNum: 1, pageSize: 500 }).then(res => { if (res.code === 0) this.countries = res.result.list || [] }) },
    resetSearch() { this.search = { customerNo:'',name:'',countryCode:'',accountNo:'',phone:'',email:'',groupId:null,status:null,isActive:null,tagId:null,regWay:null,referrer:'',activateDate:null,regDate:null }; this.fetchList() },
    handleSelectionChange(v) { this.selection = v },
    statusType(s) { const m={1:'',2:'danger',3:'warning',4:'danger'}; return m[s]||'info' },
    statusLabel(s) { const m={1:'正常',2:'禁用',3:'已注销',4:'黑名单'}; return m[s]||'--' },
    // 下面这些都是纯展示用的样式工具（原型里的 badge/ctag/mono 配色），不改任何业务逻辑
    statusBadge(s) { const m={1:'green',2:'red',3:'orange',4:'red'}; return m[s]||'gray' },
    plStyle(v) {
      const n = Number(String(v == null ? '' : v).replace(/,/g, ''))
      return { color: (!isFinite(n) || n >= 0) ? '#16a34a' : '#dc2626' }
    },
    tagPillStyle(c) {
      return { background: this.colorAlpha(c, 0.125), color: c, border: '1px solid ' + this.colorAlpha(c, 0.25) }
    },
    /** 解析客户标签 JSON，返回 [{n: 名称, c: 颜色}]；空值/脏数据返回空数组 */
    riskTags(row) {
      const raw = row && row.riskTagsJson
      if (!raw) return []
      try {
        const arr = typeof raw === 'string' ? JSON.parse(raw) : raw
        return Array.isArray(arr) ? arr.filter(t => t && t.n) : []
      } catch (e) { return [] }
    },
    // 标签颜色后端存的是十六进制或 rgba() 两种格式，统一转成带透明度的 rgba
    colorAlpha(c, alpha) {
      const color = String(c == null ? '' : c).trim()
      let m = /^#([0-9a-f]{3})$/i.exec(color)
      if (m) { const h = m[1]; return `rgba(${parseInt(h[0]+h[0],16)}, ${parseInt(h[1]+h[1],16)}, ${parseInt(h[2]+h[2],16)}, ${alpha})` }
      m = /^#([0-9a-f]{6})$/i.exec(color)
      if (m) { const h = m[1]; return `rgba(${parseInt(h.slice(0,2),16)}, ${parseInt(h.slice(2,4),16)}, ${parseInt(h.slice(4,6),16)}, ${alpha})` }
      m = /^rgba?\(([^)]+)\)$/i.exec(color)
      if (m) { const p = m[1].split(','); return `rgba(${p[0]}, ${p[1]}, ${p[2]}, ${alpha})` }
      return `rgba(90, 101, 120, ${alpha})`
    },
    verifyStatusLabel(s) { const m={1:'未认证',2:'审核中',3:'已认证',4:'已拒绝'}; return m[s]||'--' },
    verifyStatusType(s) { const m={1:'info',2:'warning',3:'success',4:'danger'}; return m[s]||'info' },
    regLabel(v) { const m={1:'H5',2:'Android',3:'IOS',4:'PC'}; return m[v]||'--' },
    groupLabel(id) { const g = this.groupOptions.find(x=>x.id===id); return g ? g.groupName : '--' },
    countryLabel(c) { const f = this.countries.find(x=>x.countryCode===c); return f ? f.countryCname||f.countryName : (c||'--') },
    docStatusLabel(s) { const m={1:'未认证',2:'审核中',3:'已认证',4:'已拒绝'}; return m[s]||'--' },
    docTypeLabel(t) { const m={1:'身份证',2:'护照',3:'驾驶证',4:'居留许可'}; return m[t]||'--' },
    walletTypeLabel(t) { const m={1:'USDT-TRC20',2:'USDT-ERC20',9:'USDT-Polygon',10:'USDT-BEP20',3:'Bitcoin',4:'Ethereum'}; return m[t]||t||'--' },
    proofTypeLabel(t) { const m={1:'水电账单',2:'银行账单',3:'政府信函',4:'居住证',5:'燃气账单'}; return m[t]||'--' },
    eventTypeLabel(code) { const t = this.eventTypes.find(x => x.code === code); return t ? t.label : (code || '--') },
    eventTypeColor(code) { const m={1:'',2:'success',3:'warning',4:'',5:'danger',6:'success',7:'danger',9:'success',10:'danger',11:'danger',13:'success',14:'danger',15:'danger',20:'success',25:'danger',26:'danger',27:'success'}; return m[code]||'' },
    /** 解析事件内容快照，返回 {entityType, changes}；非快照返回 null */
    parseEventSnapshot(content) {
      if (!content) return null
      try {
        const obj = typeof content === 'string' ? JSON.parse(content) : content
        if (obj && obj.changes && Array.isArray(obj.changes)) return obj
        return null
      } catch (e) { return null }
    },
    /** 格式化事件内容为可读文本（超长由表格省略号截断） */
    formatEventContent(content) {
      const snap = this.parseEventSnapshot(content)
      if (!snap) return content || '--'
      const parts = snap.changes.map(c => c.label + '：' + (c.old || '空') + '→' + (c.new || '空'))
      return parts.join('；')
    },
    openEventDetail(row) {
      const snap = this.parseEventSnapshot(row.content)
      if (!snap) { this.$message.info('无变更明细'); return }
      this.eventDetailEntityType = snap.entityType || ''
      this.eventDetailChanges = snap.changes || []
      this.eventDetailVisible = true
    },
    // Expand row
    onExpand(row, expandedRows) {
      if (expandedRows.some(r => r.id === row.id) && (!row.subAccounts || !row.subAccounts.length)) {
        clientAccountSubAccounts(row.id).then(res => {
          if (res.code === 0) { row.subAccounts = res.result || []; this.$set(row, 'subAccounts', row.subAccounts) }
        })
      }
    },
    // Detail
    openDetail(row) {
      clientAccountDetail(row.id).then(res => {
        if (res.code === 0) {
          this.detail = res.result; this.detailTab = 'basic'; this.detailVisible = true
          const p = res.result.permission || {}
          this.permForm = { customerId: res.result.id, deposit: p.deposit||1, withdraw: p.withdraw||1, allowOpen: p.allowOpen||1, internalTransfer: p.internalTransfer||1 }
          this.eventPageNum = 1; this.eventFilter = { type: '', operator: '', orderNo: '', timeRange: null }
          this.fetchEvents()
          this.fetchSurveyAnswer()
        }
      })
    },
    fetchSurveyAnswer() {
      if (!this.detail) return
      clientAccountSurveyAnswer(this.detail.id).then(res => {
        if (res.code === 0) this.surveyAnswer = res.result || null
      })
    },
    openSurveyResult() {
      if (!this.surveyAnswer || !this.surveyAnswer.answersJson) return
      try {
        const data = JSON.parse(this.surveyAnswer.answersJson)
        this.surveySections = data.sections || []
      } catch (e) { this.surveySections = [] }
      this.surveyResultVisible = true
    },
    // Edit
    openEdit(row) {
      this.editForm = { ...row }; this.editVisible = true; this.editTab = 'id'
      this.editBankCards = []; this.editWallets = []
      clientAccountDetail(row.id).then(res => {
        if (res.code === 0) {
          const d = res.result
          this.editForm.birthCountry = d.birthCountry || ''
          this.editForm.nationality = d.nationality || ''
          this.editForm.residenceCountry = d.residenceCountry || ''
          this.editForm.taxResidence = d.taxResidence || ''
          this.editForm.tinNumber = d.tinNumber || ''
          const p = d.permission || {}
          this.permForm = { customerId: row.id, deposit: p.deposit||1, withdraw: p.withdraw||1, allowOpen: p.allowOpen||1, allowClose: p.allowClose||1, internalTransfer: p.internalTransfer||1 }
          this.editIdCard = { docType: d.docType||1, docNumber: d.docNumber||'', docName: d.docName||'', nationality: d.docNationality||'', validFrom: d.validFrom||'', validTo: d.validTo||'', status: d.docStatus||1, frontImageUrl: d.frontImageUrl||'', backImageUrl: d.backImageUrl||'', handheldImageUrl: d.handheldImageUrl||'' }
          this.editBankCards = (d.bankCards||[]).map(c => ({...c}))
          this.editWallets = (d.wallets||[]).map(w => ({...w}))
          const addr = (d.addresses||[]).find(a => a.isCurrent === 1) || (d.addresses||[])[0] || {}
          this.editAddress = { countryCode: addr.countryCode || d.countryCode || '', address: addr.address || '', proofType: addr.proofType || null, proofFileUrls: addr.proofFileUrls || '', createDate: addr.createDate || '', pca: [addr.province, addr.city, addr.district].filter(Boolean), customerId: d.id, id: addr.id || null, isCurrent: addr.isCurrent || 1 }
        }
      })
    },
    saveEdit() {
      if (this.editBankCards.some(c => !c.bankName || !c.bankAccount || !c.bankHolder)) { this.$message.warning('银行卡的开户银行、银行卡号、持卡人为必填项'); return }
      clientAccountEditAccountAll({
        customerId: this.editForm.id, name: this.editForm.name, nickName: this.editForm.nickName,
        phonePrefix: this.editForm.phonePrefix, phoneNumber: this.editForm.phoneNumber,
        email: this.editForm.email, status: this.editForm.status, tagId: this.editForm.tagId, groupId: this.editForm.groupId,
        birthCountry: this.editForm.birthCountry, nationality: this.editForm.nationality, residenceCountry: this.editForm.residenceCountry, taxResidence: this.editForm.taxResidence, tinNumber: this.editForm.tinNumber,
        docType: this.editIdCard.docType, docNumber: this.editIdCard.docNumber,
        docName: this.editIdCard.docName, docNationality: this.editIdCard.nationality,
        validFrom: this.editIdCard.validFrom, validTo: this.editIdCard.validTo, docStatus: this.editIdCard.status,
        frontImageUrl: this.editIdCard.frontImageUrl, backImageUrl: this.editIdCard.backImageUrl, handheldImageUrl: this.editIdCard.handheldImageUrl,
        deposit: this.permForm.deposit, withdraw: this.permForm.withdraw,
        internalTransfer: this.permForm.internalTransfer, allowOpen: this.permForm.allowOpen, allowClose: this.permForm.allowClose,
        bankCards: this.editBankCards.length ? JSON.stringify(this.editBankCards) : null,
        wallets: this.editWallets.length ? JSON.stringify(this.editWallets) : null,
        addresses: (() => {
          const a = { ...this.editAddress }
          if (a.pca && a.pca.length) { a.province = a.pca[0] || ''; a.city = a.pca[1] || ''; a.district = a.pca[2] || '' }
          delete a.pca
          return a.address ? JSON.stringify([a]) : null
        })()
      }).then(res => { if (res.code === 0) { this.$message.success('保存成功'); this.editVisible = false } else { this.$message.error(res.message || '保存失败') } })
    },
    // More actions
    handleMore(cmd, row) {
      if (cmd === 'pwd') {
        this.$prompt('请输入新密码', '重置密码', { confirmButtonText: '确定', cancelButtonText: '取消', inputType: 'password', inputValidator: v => {
          if (!v) return '密码不能为空'
          if (v.length < 8 || v.length > 16) return '密码长度必须为8-16位'
          if (!/[a-z]/.test(v)) return '密码必须包含小写字母'
          if (!/[A-Z]/.test(v)) return '密码必须包含大写字母'
          if (!/\d/.test(v)) return '密码必须包含数字'
          if (!/[#@!$%^&*()_+\-=\[\]{}|;':",./<>?]/.test(v)) return '密码必须包含特殊字符(#@!等)'
          return true
        } }).then(({ value }) => {
          clientAccountResetPwd({ id: row.id, newPwd: value }).then(res => {
            if (res.code === 0) this.$message.success('密码已重置')
            else this.$message.error(res.message || '重置失败')
          })
        }).catch(() => {})
      } else if (cmd === 'disable') {
        this.$confirm('确定禁用该账户吗？', '提示', { type: 'warning' }).then(() => {
          clientAccountStatus({ id: row.id, status: 2 }).then(res => {
            if (res.code === 0) { this.$message.success('已禁用'); this.fetchList(); this.fetchStats() }
            else this.$message.error(res.message || '操作失败')
          })
        }).catch(() => {})
      } else if (cmd === 'cancel') {
        this.$confirm('确定注销该账户吗？此操作不可撤销。', '警告', { type: 'warning', confirmButtonText: '确定注销', cancelButtonText: '取消' }).then(() => {
          clientAccountStatus({ id: row.id, status: 3 }).then(res => {
            if (res.code === 0) { this.$message.success('已注销'); this.fetchList(); this.fetchStats() }
            else this.$message.error(res.message || '操作失败')
          })
        }).catch(() => {})
      }
    },
    // Add Client
    openAddClient() { this.addForm = { name:'',phone:'',email:'',groupId:null,tagId:null,referrer:'',remark:'',docType:1,docNumber:'',docName:'',nationality:'中国',validFrom:'',validTo:'',verifyStatus:1 }; this.docPreviews = [null,null,null]; this.addClientVisible = true },
    previewDoc(e, idx) { const file = e.target.files[0]; if (file) { const r = new FileReader(); r.onload = ev => { this.docPreviews[idx] = ev.target.result; this.$set(this.docPreviews, idx, ev.target.result) }; r.readAsDataURL(file) } },
    saveAddClient() {
      if (!this.addForm.name || !this.addForm.phone) { this.$message.warning('姓名和手机号为必填项'); return }
      clientAccountAdd(this.addForm).then(res => {
        if (res.code === 0) { this.$message.success('客户已创建'); this.addClientVisible = false; this.fetchList(); this.fetchStats() }
      })
    },
    // Batch Tag
    openBatchTag(type) {
      const rows = this.$refs.clientTable.selection
      if (type === 'add') {
        this.batchTag = { userIds: rows.length ? rows.map(r=>r.customerNo).join(',') : '', selectedTags: [], tip: rows.length ? '已选择 ' + rows.length + ' 个客户' : '未选择客户' }
        this.addTagVisible = true
      } else {
        this.batchDelTag = { userIds: rows.length ? rows.map(r=>r.customerNo).join(',') : '', tip: rows.length ? '已选择 ' + rows.length + ' 个客户' : '未选择客户' }
        this.delTagVisible = true
      }
    },
    batchSelectAll(type) {
      const ids = this.tableData.map(r => r.customerNo).join(',')
      if (type === 'tag') { this.batchTag.userIds = ids; this.batchTag.tip = '已选择 ' + this.tableData.length + ' 个客户' }
      else if (type === 'delTag') { this.batchDelTag.userIds = ids; this.batchDelTag.tip = '已选择 ' + this.tableData.length + ' 个客户' }
      else if (type === 'transfer') {
        if (this.multiCountry(this.tableData)) return
        this.transferForm.userIds = ids
        this.transferForm.tip = '已选择 ' + this.tableData.length + ' 个客户'
        this.resolveTransferGroups()
      }
    },
    saveBatchTag() {
      if (!this.batchTag.userIds) { this.$message.warning('请输入用户ID'); return }
      if (!this.batchTag.selectedTags.length) { this.$message.warning('请选择标签'); return }
      clientAccountBatchAddTag({ userIds: this.batchTag.userIds, tagIds: this.batchTag.selectedTags.join(',') }).then(res => {
        if (res.code === 0) { this.$message.success('已更新标签'); this.addTagVisible = false; this.fetchList() }
      })
    },
    saveBatchDelTag() {
      if (!this.batchDelTag.userIds) { this.$message.warning('请输入用户ID'); return }
      this.$confirm('确定删除所选客户的所有标签吗？','警告',{type:'warning',confirmButtonText:'确定删除',cancelButtonText:'取消'}).then(() => {
        clientAccountBatchRemoveTag({ userIds: this.batchDelTag.userIds }).then(res => {
          if (res.code === 0) { this.$message.success('已删除标签'); this.delTagVisible = false; this.fetchList() }
        })
      })
    },
    // Transfer Group
    openTransferGroup() {
      const rows = this.$refs.clientTable.selection
      if (this.multiCountry(rows)) return
      this.transferForm = { userIds: rows.length ? rows.map(r=>r.customerNo).join(',') : '', targetGroupId: null, reason: '', tip: rows.length ? '已选择 ' + rows.length + ' 个客户' : '未选择客户' }
      this.transferVisible = true
      if (rows.length) this.resolveTransferGroups()
    },
    /** 客户组按国家维护：所选客户跨多个国家时不支持批量转组，提示分批操作并返回 true */
    multiCountry(rows) {
      const countries = [...new Set(rows.map(r => r.countryCode).filter(Boolean))]
      if (countries.length > 1) {
        this.$message.error('所选客户涉及多个国家，暂不支持批量转组，请分批操作')
        return true
      }
      return false
    },
    /** 目标客户组由后端按所选客户所在国家返回（跨国家时后端同样会拦截） */
    resolveTransferGroups() {
      this.transferForm.targetGroupId = null
      this.transferGroupOptions = []
      this.transferCountryCode = ''
      if (!this.transferForm.userIds) return
      // 反复失焦/点「全选当前」会并发请求，只采用最后一次的结果，避免旧响应覆盖新选择
      const seq = ++this.transferReqSeq
      clientAccountTransferTargets({ userIds: this.transferForm.userIds }).then(res => {
        if (seq !== this.transferReqSeq) return
        if (res.code === 0) {
          const data = res.result || {}
          this.transferCountryCode = data.countryCode || ''
          this.transferGroupOptions = data.groups || []
          if (!this.transferGroupOptions.length) this.$message.warning('所选客户所在国家暂无客户组，无法转组')
        }
      }).catch(() => {})
    },
    saveTransferGroup() {
      if (!this.transferForm.userIds) { this.$message.warning('请输入用户ID'); return }
      if (!this.transferForm.targetGroupId) { this.$message.warning('请选择目标客户组'); return }
      this.$confirm('确定将所选客户转至目标客户组吗？','确认转组',{type:'warning'}).then(() => {
        clientAccountBatchTransferGroup({ userIds: this.transferForm.userIds, targetGroupId: this.transferForm.targetGroupId, reason: this.transferForm.reason }).then(res => {
          if (res.code === 0) { this.$message.success('已转组'); this.transferVisible = false; this.fetchList() }
        })
      })
    },
    // Export
    handleExport() {
      const rows = this.$refs.clientTable.selection
      const params = { ...this.search }
      if (rows.length > 0) params.ids = rows.map(r => r.customerNo).join(',')
      clientAccountExport(params).then(res => {
        const blob = res instanceof Blob ? res : new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url; a.download = '客户账号.xlsx'; a.click()
        window.URL.revokeObjectURL(url)
      })
    },
    permVal(field) { return this.detail && this.detail.permission ? (this.detail.permission[field] || 1) : 1 },
    savePermission() { clientAccountPermissionUpdate(this.permForm).then(res => { if (res.code === 0) this.$message.success('权限已更新') }) },
    deleteWallet(idx) { this.$confirm('确定删除该电子钱包吗？', '提示', { type: 'warning' }).then(() => { this.editWallets.splice(idx, 1) }) },
    addBankCard() { this.editBankCards.push({bankName:'',bankCode:'',bankAccount:'',bankHolder:'',branch:'',countryCode:'',bankSwift:'',bankIban:'',bankSortCode:'',status:1}) },
    addWallet() { this.editWallets.push({walletType:1,address:'',holder:'',status:1}) },
    deleteBankCard(idx) { this.$confirm('确定删除该银行卡吗？', '提示', { type: 'warning' }).then(() => { this.editBankCards.splice(idx, 1) }) },
    previewAddrDoc(e) { const file = e.target.files[0]; if (file) { const r = new FileReader(); r.onload = ev => { this.editAddress.proofFileUrls = ev.target.result }; r.readAsDataURL(file) } },
    onPcaChange(v) { console.log('省市区 value:', v); console.log('省:', v && v[0], '市:', v && v[1], '区:', v && v[2]) },
    /** DB码(43/4313/431322)转为中文名称(湖南省/娄底市/新化县) */
    areaLabel(addr) {
      if (!addr || !addr.province) return addr && addr.address ? addr.address : '--'
      const p = codeToText[addr.province] || ''
      const c = codeToText[addr.city] || ''
      const d = codeToText[addr.district] || ''
      return (p + c + d + (addr.address || '')).replace(/\s+/g, '') || '--'
    },
    // Event logs
    fetchEvents() {
      if (!this.detail) return
      const params = { customerId: this.detail.id, pageNum: this.eventPageNum, pageSize: this.eventPageSize, eventType: this.eventFilter.type, operator: this.eventFilter.operator, orderNo: this.eventFilter.orderNo }
      if (this.eventFilter.timeRange && this.eventFilter.timeRange.length) { params.operateTimeBegin = this.eventFilter.timeRange[0]; params.operateTimeEnd = this.eventFilter.timeRange[1] }
      clientAccountEventLogs(params).then(res => {
        if (res.code === 0) { this.eventLogs = res.result.list || []; this.eventTotal = res.result.total || 0 }
      })
    },
    onEventSearch() { this.eventPageNum = 1; this.fetchEvents() },
    resetEventFilter() { this.eventFilter = { type: '', operator: '', orderNo: '', timeRange: null }; this.eventPageNum = 1; this.fetchEvents() },
    // Sub account actions
    showSubAccountDetail(customer, sub) {
      this.subDetail = {
        customerNo: customer.customerNo, userName: customer.name, regTime: customer.regTime,
        accountNo: sub.accountNo, accountType: sub.accountType, tradeGroupName: sub.tradeGroupName, status: sub.status,
        balance: sub.balance, equity: sub.equity, marginFree: sub.marginFree, marginInitial: sub.marginInitial, floatingPl: sub.floatingPl
      }
      this.subDetailTab = sub.accountType === 1 ? 'fund' : 'positions'
      this.posPageNum = 1; this.dealPageNum = 1; this.orderPageNum = 1; this.ffPageNum = 1
      this.posSearch = { position: '', symbol: '', action: null }
      this.dealSearch = { deal: '', symbol: '', action: null }
      this.orderSearch = { order: '', symbol: '', type: null }
      this.ffSearch = { flowNo: '', subjectType: null, timeRange: null }
      this.posList = []; this.dealList = []; this.orderList = []; this.ffList = []
      this.posLoaded = false; this.orderLoaded = false; this.dealLoaded = false; this.ffLoaded = false
      this.subDetailVisible = true
      if (sub.accountType !== 1) { this.fetchSubCounts() }
      this.switchSubDetailTab(this.subDetailTab)
    },
    switchSubDetailTab(tab) {
      this.subDetailTab = tab
      if (tab === 'positions' && !this.posLoaded) { this.posLoaded = true; this.fetchSubPositions() }
      else if (tab === 'orders' && !this.orderLoaded) { this.orderLoaded = true; this.fetchSubOrders() }
      else if (tab === 'deals' && !this.dealLoaded) { this.dealLoaded = true; this.fetchSubDeals() }
      else if (tab === 'fund' && !this.ffLoaded) { this.ffLoaded = true; this.fetchSubFundFlows() }
    },
    fetchSubCounts() {
      if (!this.subDetail) return
      clientAccountSubAccountCounts(this.subDetail.accountNo).then(res => {
        if (res.code === 0) {
          const r = res.result || {}
          this.posTotal = r.positions || 0
          this.orderTotal = r.orders || 0
          this.dealTotal = r.deals || 0
          this.ffTotal = r.fundFlow || 0
        }
      })
    },
    subAccountTypeLabel(t) { const m = {1:'钱包账户',2:'真实账户',3:'模拟账户'}; return m[t]||'--' },
    fmtMoney(v) { return v != null ? Number(v).toFixed(2) : '-' },
    fmtDateTime(t) { return t ? String(t).replace('T', ' ').substring(0, 19) : '-' },
    volumeToLots(v) { return v != null ? (v / 10000) : '-' },
    fmtPrice(p, digits) { return p != null ? p.toFixed(digits != null ? digits : 2) : '-' },
    fmtGmt8(t) {
      if (!t) return '-'
      // MT5 服务器时区为 GMT+3，转成 GMT+8 需 +5 小时
      const d = new Date(String(t).replace(' ', 'T') + (String(t).includes('Z') ? '' : 'Z'))
      if (isNaN(d.getTime())) return t
      d.setUTCHours(d.getUTCHours() + 5)
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getUTCFullYear()}-${p(d.getUTCMonth() + 1)}-${p(d.getUTCDate())} ${p(d.getUTCHours())}:${p(d.getUTCMinutes())}:${p(d.getUTCSeconds())}`
    },
    fetchSubPositions() {
      if (!this.subDetail) return
      this.posLoading = true
      clientAccountSubAccountPositions({
        login: this.subDetail.accountNo, position: this.posSearch.position || undefined,
        symbol: this.posSearch.symbol || undefined, action: this.posSearch.action,
        pageNum: this.posPageNum, pageSize: this.posPageSize
      }).then(res => {
        if (res.code === 0) { this.posList = res.result.list || []; this.posTotal = res.result.total || 0 }
      }).finally(() => { this.posLoading = false })
    },
    fetchSubDeals() {
      if (!this.subDetail) return
      this.dealLoading = true
      clientAccountSubAccountDeals({
        login: this.subDetail.accountNo, deal: this.dealSearch.deal || undefined,
        symbol: this.dealSearch.symbol || undefined, action: this.dealSearch.action,
        pageNum: this.dealPageNum, pageSize: this.dealPageSize
      }).then(res => {
        if (res.code === 0) { this.dealList = res.result.list || []; this.dealTotal = res.result.total || 0 }
      }).finally(() => { this.dealLoading = false })
    },
    searchPositions() { this.posPageNum = 1; this.fetchSubPositions() },
    resetPositions() { this.posSearch = { position: '', symbol: '', action: null }; this.posPageNum = 1; this.fetchSubPositions() },
    searchDeals() { this.dealPageNum = 1; this.fetchSubDeals() },
    resetDeals() { this.dealSearch = { deal: '', symbol: '', action: null }; this.dealPageNum = 1; this.fetchSubDeals() },
    fetchSubOrders() {
      if (!this.subDetail) return
      this.orderLoading = true
      clientAccountSubAccountOrders({
        login: this.subDetail.accountNo, order: this.orderSearch.order || undefined,
        symbol: this.orderSearch.symbol || undefined, type: this.orderSearch.type,
        pageNum: this.orderPageNum, pageSize: this.orderPageSize
      }).then(res => {
        if (res.code === 0) { this.orderList = res.result.list || []; this.orderTotal = res.result.total || 0 }
      }).finally(() => { this.orderLoading = false })
    },
    searchOrders() { this.orderPageNum = 1; this.fetchSubOrders() },
    resetOrders() { this.orderSearch = { order: '', symbol: '', type: null }; this.orderPageNum = 1; this.fetchSubOrders() },
    fetchSubFundFlows() {
      if (!this.subDetail) return
      this.ffLoading = true
      const params = {
        accountNo: this.subDetail.accountNo,
        flowNo: this.ffSearch.flowNo || undefined,
        subjectType: this.ffSearch.subjectType,
        pageNum: this.ffPageNum, pageSize: this.ffPageSize
      }
      if (this.ffSearch.timeRange && this.ffSearch.timeRange.length) {
        params.startTime = this.ffSearch.timeRange[0]
        params.endTime = this.ffSearch.timeRange[1]
      }
      fundFlowList(params).then(res => {
        if (res.code === 0) { this.ffList = res.result.list || []; this.ffTotal = res.result.total || 0 }
      }).finally(() => { this.ffLoading = false })
    },
    searchFundFlows() { this.ffPageNum = 1; this.fetchSubFundFlows() },
    resetFundFlows() { this.ffSearch = { flowNo: '', subjectType: null, timeRange: null }; this.ffPageNum = 1; this.fetchSubFundFlows() },
    closePosition(row) {
      this.$confirm(`确定平仓 ${row.symbol} 持仓（单号 ${row.position}）吗？`, '平仓确认', { type: 'warning' }).then(() => {
        // 全屏蒙层：平仓请求期间挡住重复点击，成功/失败都要关闭
        const loading = this.$loading({
          lock: true,
          text: '平仓处理中，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        })
        clientAccountSubAccountClosePosition({
          login: this.subDetail.accountNo, position: row.position, symbol: row.symbol, volume: row.volume, action: row.action
        }).then(res => {
          if (res.code === 0) { this.$message.success('平仓请求已提交'); this.fetchSubPositions(); this.fetchSubCounts() }
          else this.$message.error(res.message || '平仓失败')
        }).catch(() => {
          this.$message.error('平仓失败，请稍后重试')
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {})
    },
    cancelOrder(row) {
      this.$confirm(`确定撤销委托 ${row.symbol}（单号 ${row.order}）吗？`, '撤单确认', { type: 'warning' }).then(() => {
        // 全屏蒙层：撤单请求期间挡住重复点击，成功/失败都要关闭
        const loading = this.$loading({
          lock: true,
          text: '撤单处理中，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        })
        clientAccountSubAccountCancelOrder({
          login: this.subDetail.accountNo, order: row.order, symbol: row.symbol
        }).then(res => {
          if (res.code === 0) { this.$message.success('撤单请求已提交'); this.fetchSubOrders(); this.fetchSubCounts() }
          else this.$message.error(res.message || '撤单失败')
        }).catch(() => {
          this.$message.error('撤单失败，请稍后重试')
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {})
    },
    orderTypeLabel(t) { const m = {0:'买入',1:'卖出',2:'买入限价',3:'卖出限价',4:'买入止损',5:'卖出止损',6:'买入停损限价',7:'卖出停损限价',8:'相互平仓'}; return m[t] || (t != null ? t : '-') },
    orderStateLabel(s) { const m = {0:'等待处理',1:'已下单',2:'已取消',3:'部分成交',4:'已成交',5:'已拒绝',6:'已到期'}; return m[s] || (s != null ? s : '-') },
    orderStateType(s) { const m = {0:'info',1:'',2:'info',3:'warning',4:'success',5:'danger',6:'info'}; return m[s] || 'info' },
    orderDirectionLabel(t) { const buy = [0,2,4,6]; const sell = [1,3,5,7]; return buy.includes(t) ? '买入' : (sell.includes(t) ? '卖出' : '-') },
    // 指定时间/指定日期附上具体到期时刻；未设到期时 MT5 存的是 1970-01-01 哨兵值，不展示
    orderTimeTypeLabel(t, exp) {
      const m = {0:'取消前有效',1:'当天',2:'指定时间',3:'指定日期'}
      const label = m[t] || (t != null ? t : '-')
      if ((t !== 2 && t !== 3) || !exp || String(exp).substring(0, 4) < '1971') return label
      return t === 2 ? `${label}(${this.fmtGmt8(exp)})` : `${label}(${this.expiryDateOnly(exp)})`
    },
    // 指定日期只显示到日：MT5 把「有效至某日」落库为该日次日零点（broker 时间），换算 GMT+8 后减一天即客户所选日
    expiryDateOnly(exp) {
      const s = this.fmtGmt8(exp)
      const d = new Date(s.replace(' ', 'T') + 'Z')
      if (isNaN(d.getTime())) return s
      d.setUTCDate(d.getUTCDate() - 1)
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getUTCFullYear()}-${p(d.getUTCMonth() + 1)}-${p(d.getUTCDate())}`
    },
    dealEntryLabel(e) { const m = {0:'开仓',1:'平仓',2:'反转',3:'对冲平仓'}; return m[e] || (e != null ? e : '-') },
    editSubAccount(customer, sub) {
      this.subEdit = {
        accountNo: sub.accountNo, login: sub.accountNo, userName: customer.name,
        accountType: sub.accountType, status: sub.status,
        tradeGroupName: sub.tradeGroupName || '', groupOptions: sub.tradeGroupName ? [sub.tradeGroupName] : [],
        marginLeverage: sub.marginLeverage != null ? sub.marginLeverage : '',
        deposit: 1, withdraw: 1, internalTransfer: 1, allowOpen: 1, allowClose: 1
      }
      this.subEditVisible = true
      clientAccountSubAccountPermissionGet(sub.accountNo).then(res => {
        if (res.code === 0 && res.result) {
          const p = res.result
          this.subEdit.deposit = p.deposit || 1
          this.subEdit.withdraw = p.withdraw || 1
          this.subEdit.internalTransfer = p.internalTransfer || 1
          this.subEdit.allowOpen = p.allowOpen || 1
          this.subEdit.allowClose = p.allowClose || 1
        }
      })
    },
    saveSubAccountEdit() {
      clientAccountSubAccountEdit({
        accountNo: this.subEdit.accountNo, tradeGroupName: this.subEdit.tradeGroupName,
        marginLeverage: this.subEdit.marginLeverage,
        deposit: this.subEdit.deposit, withdraw: this.subEdit.withdraw,
        internalTransfer: this.subEdit.internalTransfer, allowOpen: this.subEdit.allowOpen, allowClose: this.subEdit.allowClose
      }).then(res => {
        if (res.code === 0) { this.$message.success('交易账号已保存'); this.subEditVisible = false; this.fetchList() }
        else this.$message.error(res.message || '保存失败')
      })
    },
    // Inline remark edit
    startEditRemark(row) {
      this.$set(row, 'remarkEdit', row.remark || '')
      this.$set(row, 'editingRemark', true)
      this.$nextTick(() => {
        // 只聚焦当前这一行的备注输入框。原来用 document.querySelector('.el-input__inner')
        // 拿到的是整页第一个输入框（顶部筛选栏那个），聚焦后浏览器把它滚进视口，
        // 整个列表会跳到顶部，备注框反而看不见。
        const ref = this.$refs['remarkInput' + row.id]
        const input = Array.isArray(ref) ? ref[0] : ref
        if (input && input.focus) input.focus()
      })
    },
    saveRemark(row) {
      const val = (row.remarkEdit || '').trim()
      if (val === (row.remark || '')) { this.$set(row, 'editingRemark', false); return }
      clientAccountUpdateAccount({ customerId: row.id, remark: val }).then(res => {
        if (res.code === 0) { this.$set(row, 'remark', val); this.$message.success('备注已更新') }
        else this.$message.error(res.message || '更新失败')
      }).finally(() => { this.$set(row, 'editingRemark', false) })
    },
  }
}
</script>

<style scoped>
.page-container { background: #f4f6fb; min-height: calc(100vh - 84px); padding: 16px; }
.stats-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 24px; }
.stat-card { background: #fff; border: 1px solid #e8ecf2; border-radius: 12px; padding: 20px; transition: all 0.2s; }
.stat-card:hover { border-color: #d1d9e6; transform: translateY(-1px); }
.stat-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.stat-label { font-size: 13px; color: #5a6578; font-weight: 500; }
.stat-icon { width: 36px; height: 36px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 16px; }
.stat-icon.green { background: var(--brand-primary-a08); color: var(--brand-primary); } .stat-icon.blue { background: rgba(37,99,235,0.08); } .stat-icon.amber { background: rgba(230,168,23,0.08); }
.stat-value { font-size: 28px; font-weight: 600; color: #1a2236; margin-bottom: 6px; letter-spacing: -1px; font-family: 'JetBrains Mono','DM Sans',sans-serif; }
.stat-change { display: flex; align-items: center; gap: 4px; font-size: 12px; } .stat-change.up { color: #16a34a; } .stat-change .change-text { color: #9ca3af; font-weight: 400; }
.filter-bar { background: #fff; border: 1px solid #e8ecf2; border-radius: 12px; padding: 16px 20px; margin-bottom: 16px; }
.table-wrapper { background: #fff; border: 1px solid #e8ecf2; border-radius: 12px; padding: 0; overflow: hidden; }
.table-header { display: flex; align-items: center; justify-content: space-between; padding: 14px 20px; border-bottom: 1px solid #e8ecf2; }
.table-title { font-size: 14px; font-weight: 600; color: #1a2236; }
.table-actions { display: flex; gap: 8px; align-items: center; }
.btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; border-radius: 6px; font-size: 13px; font-weight: 500; font-family: inherit; cursor: pointer; transition: all 0.15s; border: 1px solid transparent; white-space: nowrap; }
.btn-primary { background: var(--brand-primary); color: #fff; border-color: var(--brand-primary); }
.btn-primary:hover { background: var(--brand-primary-hover); border-color: var(--brand-primary-hover); }
.btn-primary:active { transform: scale(0.97); }
.btn-secondary { background: transparent; color: #5a6578; border-color: #e8ecf2; }
.btn-secondary:hover { border-color: #9ca3af; color: #1a2236; }
.btn-sm { padding: 5px 10px; font-size: 12px; }

/* ===== 客户列表表格皮肤（表头小字大写灰、单元格 13px 次级色；列间竖线见下方「列分隔竖线」） ===== */
/* 注意：项目用的是 element-ui 2.13.0，单元格没有 el-table__cell 这个类（2.15 才加），
   所以这里直接选 td / th；el-table 的 .cell 默认左右各 10px，配合 td 的 6px 得到原型的 16px */
/deep/ .client-table { color: #5a6578; }
/deep/ .client-table::before { display: none; }
/deep/ .client-table .el-table__header-wrapper thead > tr > th,
/deep/ .client-table .el-table__fixed-header-wrapper thead > tr > th {
  background: rgba(0,0,0,0.05); border-bottom: 1px solid #e8ecf2; padding: 10px 6px;
  color: #9ca3af; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;
}
/deep/ .client-table .el-table__body-wrapper table.el-table__body > tbody > tr > td,
/deep/ .client-table .el-table__fixed-body-wrapper table.el-table__body > tbody > tr > td {
  padding: 12px 6px; font-size: 13px; color: #5a6578; border-bottom: 1px solid #e8ecf2;
}
/* 列分隔竖线：每个单元格加右侧线，最后一列（操作列，fixed=right）除外——
   表格右外框由 .table-wrapper 自己的 1px #e8ecf2 负责，再加一条会叠成双线。
   操作列和滚动区之间那条竖线，改由 fixed 层的 border-left 画。
   展开行是整行 colspan 的单个 td，天然命中 :last-child，所以不会被竖线横穿。
   颜色取和行线一致的 #e8ecf2，不用 element 默认的 #EBEEF5，免得两种灰混在一张表里 */
/deep/ .client-table .el-table__header-wrapper thead > tr > th:not(:last-child),
/deep/ .client-table .el-table__body-wrapper table.el-table__body > tbody > tr > td:not(:last-child) {
  border-right: 1px solid #e8ecf2;
}
/deep/ .client-table .el-table__fixed-header-wrapper thead > tr > th,
/deep/ .client-table .el-table__fixed-body-wrapper table.el-table__body > tbody > tr > td {
  border-left: 1px solid #e8ecf2;
}
/* 展开行整行变成浅灰底（原型 tr.expand-row td 的 --bg-primary）。element 给 .el-table__expanded-cell:hover
   写了 background:transparent!important，这里必须同样用 !important 才能压住，否则鼠标移上去灰底会闪白 */
/deep/ .client-table .el-table__body-wrapper table.el-table__body > tbody > tr > td.el-table__expanded-cell { padding: 0; background: #f4f6fb !important; }
/deep/ .client-table .el-table__body-wrapper table.el-table__body > tbody > tr:hover > td,
/deep/ .client-table .el-table__fixed-body-wrapper table.el-table__body > tbody > tr:hover > td { background: #f8f9fc; }
/* 勾选列 / 展开列只有 30px，去掉单元格左右内边距才能居中不裁切（原型这两个列也是 30px） */
/deep/ .client-table .el-table__header-wrapper thead > tr > th.el-table-column--selection,
/deep/ .client-table .el-table__header-wrapper thead > tr > th.el-table__expand-column,
/deep/ .client-table .el-table__fixed-header-wrapper thead > tr > th.el-table-column--selection,
/deep/ .client-table .el-table__fixed-header-wrapper thead > tr > th.el-table__expand-column,
/deep/ .client-table .el-table__body-wrapper table.el-table__body > tbody > tr > td.el-table-column--selection,
/deep/ .client-table .el-table__body-wrapper table.el-table__body > tbody > tr > td.el-table__expand-column,
/deep/ .client-table .el-table__fixed-body-wrapper table.el-table__body > tbody > tr > td.el-table-column--selection,
/deep/ .client-table .el-table__fixed-body-wrapper table.el-table__body > tbody > tr > td.el-table__expand-column { padding: 0; }
/deep/ .client-table td.el-table-column--selection .cell,
/deep/ .client-table th.el-table-column--selection > .cell { padding: 0; text-align: center; }
/deep/ .client-table .el-table__fixed::before, /deep/ .client-table .el-table__fixed-right::before { display: none; }
/deep/ .client-table .cell { line-height: 1.5; }
/* 等宽字体列：元素数量要和上面那条 td 规则一致，不然会被它的 13px 盖掉 */
/deep/ .client-table .el-table__body-wrapper table.el-table__body > tbody > tr > td.mono-cell,
/deep/ .client-table .el-table__fixed-body-wrapper table.el-table__body > tbody > tr > td.mono-cell,
/deep/ .client-table .sub-table .el-table__body-wrapper table.el-table__body > tbody > tr > td.mono-cell { font-family: 'JetBrains Mono', monospace; font-size: 12.5px; }

/* 展开按钮 1:1 对齐原型：20px 圆角方块 + 实心三角 ▶，展开时整体旋转 90°
   原型用的是实心三角「字符」（html 里就是一个 ▶），element 默认给的是 element-icons 图标字体里的细箭头，
   所以这里把内层 <i class="el-icon el-icon-arrow-right"> 藏掉、直接用同一个字符画。
   注意 :before 上必须显式写字体：i.el-icon 上那条 font-family: element-icons!important 会一路继承到伪元素，
   不覆盖的话 ▶ 在图标字体里没有对应字形，会渲染成方框 */
/deep/ .el-table__expand-icon { width: 20px; height: 20px; margin: 0 auto; border: none; border-radius: 4px; color: #9ca3af; background: transparent; text-align: center; transition: transform 0.2s ease-in-out, background-color 0.2s, color 0.2s; }
/deep/ .el-table__expand-icon > .el-icon { display: none; }
/deep/ .el-table__expand-icon::before { content: '\25B6'; font-family: 'DM Sans', 'Microsoft YaHei', 'PingFang SC', Arial, sans-serif; font-size: 11px; line-height: 20px; }
/deep/ .el-table__expand-icon:hover { background: var(--brand-primary-a08); color: var(--brand-primary); }

/* ===== 子账户明细（展开行，1:1 对齐原型） ===== */
/* 子表是嵌在客户表里的，外层那几条 td/th 规则同样会命中子表的单元格，
   所以这里的选择器都带上 .client-table .sub-table 前缀，保证子表样式压得住外层 */
/* element 给展开列的内层 cell 加了 text-align:center，这里要显式改回左对齐（原型是左对齐） */
/* 右边要留出主表固定列（操作列，见模板 <el-table-column label="操作" width="200" fixed="right">）的宽度：
   展开行的可用宽度是整张表的 2330px，子表铺满后最后一列正好落在固定列底下，
   横向滚到最右时子表右边界看不见、两个图标按钮像跑出了子表。
   让掉 200 + 24 之后，子表右边界停在固定列左边界左侧 24px（和左边距对称），
   按钮就完整留在子表里、也能点。注意：改主表操作列的 width 时，这个 224 要跟着改 */
.expand-content { padding: 16px 224px 16px 24px; text-align: left; }
.sub-table-title { font-size: 12px; font-weight: 600; color: #5a6578; margin-bottom: 10px; text-transform: uppercase; letter-spacing: 0.5px; }
/deep/ .client-table .sub-table { border: none; }
/deep/ .client-table .sub-table::before { display: none; }
/deep/ .client-table .sub-table .el-table__header-wrapper thead > tr > th {
  background: rgba(0,0,0,0.03); border-bottom: 1px solid #e8ecf2; padding: 8px 2px;
  color: #9ca3af; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;
}
/deep/ .client-table .sub-table .el-table__body-wrapper table.el-table__body > tbody > tr > td {
  padding: 10px 2px; font-size: 12.5px; color: #5a6578; border-bottom: 1px solid #e8ecf2;
}
/deep/ .client-table .sub-table .el-table__body-wrapper table.el-table__body > tbody > tr:hover > td { background: #f8f9fc; }
/deep/ .client-table .sub-table .cell { line-height: 1.5; }
/* 子账户行内操作：两个按钮强制排一行不换行、不压缩（原型是一行两个 30x30 按钮） */
.sub-actions { display: flex; flex-wrap: nowrap; gap: 6px; }

/* ===== 徽标 / 标签 / 备注（原型配色） ===== */
.badge { display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 500; white-space: nowrap; }
.badge.green { background: rgba(22,163,74,0.08); color: #16a34a; }
.badge.blue { background: rgba(37,99,235,0.08); color: #2563eb; }
.badge.red { background: rgba(220,38,38,0.06); color: #dc2626; }
.badge.orange { background: #fff7e6; color: #d46b08; }
.badge.gray { background: rgba(90,101,120,0.15); color: #9ca3af; }
.badge-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }
.badge.green .badge-dot { background: #16a34a; }
.badge.blue .badge-dot { background: #2563eb; }
.badge.red .badge-dot { background: #dc2626; }
.badge.orange .badge-dot { background: #d46b08; }
.badge.gray .badge-dot { background: #9ca3af; }
.ctag { display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 500; margin-right: 4px; white-space: nowrap; }
.ctag-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }
/* 客户标签列：只展示第一个标签，多于一个时补「…」提示，悬浮出 tooltip 看全部 */
.ctag-cell { display: inline-flex; align-items: center; max-width: 100%; }
.ctag-cell .ctag { margin-right: 0; }
.ctag-more { margin-left: 2px; color: #9ca3af; font-size: 12px; font-weight: 500; flex-shrink: 0; }
/* tooltip 里沿用同一套彩色胶囊（换行排列），配 effect="light" 的白底 */
.ctag-tip { display: flex; flex-wrap: wrap; max-width: 260px; row-gap: 6px; }
.remark-cell { display: inline-block; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: middle; cursor: pointer; padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 500; }
.remark-cell:not(.remark-cell-empty) { background: rgba(220,38,38,0.06); color: #dc2626; }
.remark-cell-empty { background: rgba(22,163,74,0.08); color: #16a34a; }

/* 子账户行内操作按钮：30x30 图标按钮（原型 .btn-icon：padding 6px、30x30、圆角 6px） */
.icon-btn { width: 30px; height: 30px; flex-shrink: 0; display: inline-flex; align-items: center; justify-content: center; padding: 0; border-radius: 6px; border: 1px solid #e8ecf2; background: transparent; color: #5a6578; font-size: 12px; cursor: pointer; transition: all 0.15s; }
.icon-btn:hover { border-color: #9ca3af; color: #1a2236; }
.icon-btn-edit { background: var(--brand-primary-a08); color: var(--brand-primary); border-color: var(--brand-primary-border); }
.icon-btn-edit:hover { color: var(--brand-primary); border-color: var(--brand-primary); }

/* 主列表操作列：原型是「详情 / 编辑 / 更多 ▾」三个文字链接排一行
   ① nowrap 保证不折行（element 的 .cell 默认 white-space:normal，会折成两行）
   ② 样式抄原型的 .btn-link：品牌色、12px、padding 4px 8px、hover 下划线
   列宽 <el-table-column width="200">：无头 Edge 实测三个链接内容 139.3px
   （详情 42 + 编辑 42 + 更多 ▾ 55.3）+ .cell 左右 padding 20 + td 左右 padding 12 = 171.3px，
   取 200 留 ~17% 余量（换机器/字体回退时更宽也不会又折行） */
/deep/ .client-table .el-table__body-wrapper table.el-table__body > tbody > tr > td.op-cell .cell,
/deep/ .client-table .el-table__fixed-body-wrapper table.el-table__body > tbody > tr > td.op-cell .cell { white-space: nowrap; }
/deep/ .client-table .el-button--text { color: var(--brand-primary); font-size: 12px; padding: 4px 8px; }
/deep/ .client-table .el-button--text:hover { color: var(--brand-primary-hover); text-decoration: underline; }
/deep/ .client-table .el-button--text + .el-button--text { margin-left: 0; }
/* 不要给 .el-dropdown 加 vertical-align:middle —— el-button 是基线对齐的，
   加了会让「更多 ▾」比另外两个链接低 1px（实测 90.8/90.8/91.8），去掉后三个顶边一致 */
/deep/ .client-table .el-dropdown { margin-left: 0; }

/* 分页条对齐原型（顶部线 + 品牌色当前页） */
/deep/ .el-pagination { padding: 14px 20px; border-top: 1px solid #e8ecf2; margin: 0; }
/deep/ .el-pager li.active { background: var(--brand-primary); color: #fff; border-radius: 6px; }
/deep/ .el-pager li:hover { color: var(--brand-primary); }
.info-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }
.info-item { display: flex; flex-direction: column; gap: 4px; }
.info-label { font-size: 12px; color: #5a6578; }
.info-val { font-size: 14px; color: #1a2236; }
.avatar-circle { width: 40px; height: 40px; border-radius: 50%; background: linear-gradient(135deg,var(--brand-primary-hover),var(--brand-primary)); color:#fff; display:flex;align-items:center;justify-content:center;font-weight:700;font-size:18px; }
.edit-section { margin-bottom: 8px; }
.edit-section-title { font-size: 14px; font-weight: 600; color: #1a2236; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #e8ecf2; }
.doc-upload-item { width: 140px; text-align: center; }
.doc-upload-box { width: 140px; height: 100px; border: 1px dashed #d1d9e6; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #9ca3af; background: #f4f6fb; cursor: pointer; position: relative; overflow: hidden; }
.doc-upload-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; opacity: 0; transition: opacity 0.2s; border-radius: 8px; color: #fff; font-size: 13px; font-weight: 500; }
.doc-upload-box:hover .doc-upload-overlay { opacity: 1; }
.overview-bar { display: flex; flex-wrap: wrap; gap: 0; border: 1px solid #e8ecf2; border-radius: 10px; overflow: hidden; margin-bottom: 16px; }
.overview-item { flex: 1; min-width: 100px; padding: 12px 16px; text-align: center; border-right: 1px solid #e8ecf2; background: #fafbfc; }
.overview-item:last-child { border-right: none; }
.ov-label { font-size: 11px; color: #9ca3af; margin-bottom: 4px; }
.ov-value { font-size: 14px; font-weight: 600; color: #1a2236; }
.ov-value.green { color: #16a34a; }
.ov-value.orange { color: #e6a817; }
.ov-value.red { color: #dc2626; }
.ov-value.gray { color: #9ca3af; }
.detail-section { margin-bottom: 16px; }
.detail-section-title { font-size: 14px; font-weight: 600; color: #1a2236; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #e8ecf2; }
.detail-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.detail-item { display: flex; flex-direction: column; gap: 4px; }
.di-label { font-size: 12px; color: #5a6578; }
.di-value { font-size: 14px; color: #1a2236; font-weight: 500; }
.tab-btn.active { background: var(--brand-primary) !important; color: #fff !important; border-color: var(--brand-primary) !important; }
.mono { font-family: 'JetBrains Mono', monospace; }
.edit-form-group { margin-bottom: 4px; }
.edit-form-group label { display: block; font-size: 13px; color: #5a6578; margin-bottom: 4px; }
.perm-card { display: flex; align-items: center; gap: 12px; padding: 14px 16px; border: 1px solid #e8ecf2; border-radius: 8px; background: #f4f6fb; }
.perm-icon { width: 36px; height: 36px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 16px; flex-shrink: 0; }
.perm-icon.green { background: rgba(16,185,129,0.1); color: #16a34a; }
.perm-icon.blue { background: rgba(59,130,246,0.1); color: #00897b; }
.perm-icon.orange { background: rgba(245,158,11,0.1); color: #d97706; }
.perm-icon.red { background: rgba(239,68,68,0.1); color: #dc2626; }
.perm-icon.cyan { background: rgba(6,182,212,0.1); color: #0891b2; }
.perm-info { flex: 1; }
.perm-title { font-size: 13px; font-weight: 600; color: #1a2236; }
.perm-desc { font-size: 12px; color: #9ca3af; margin-top: 2px; }
.edit-form-group label.required::before { content: '*'; color: #f56c6c; margin-right: 3px; }
</style>

